const dashboard = {
  // Page-level
  "dashboard.title": "لوحة التحكم",
  "dashboard.connectPrompt": "قم بتوصيل واتساب للبدء",
  "dashboard.session": "الجلسة",
  "dashboard.plan": "الخطة",
  "dashboard.loading": "جاري تحميل لوحة التحكم...",
  "dashboard.error.title": "فشل تحميل البيانات",
  "dashboard.error.needReconnect": "تحتاج جلسة واتساب إلى إعادة اتصال. إعادة المسح ستسمح لك بمسح كود QR جديد.",
  "dashboard.error.restartScan": "إعادة المسح",
  "dashboard.error.signInAgain": "تسجيل الدخول مجدداً",
  "dashboard.error.tokenExpiredDesc": "انتهت صلاحية رمز الاتصال أو جلسة العمل على الخادم. تسجيل الدخول برقم هاتفك مجدداً سيقوم بتحديث الرمز واستعادة الوصول للوحة فوراً.",
  "dashboard.tabs.overview": "نظرة عامة",
  "dashboard.tabs.automation": "الأتمتة",
  "dashboard.tabs.knowledge": "قاعدة المعرفة",
  "dashboard.tabs.blacklist": "القائمة السوداء",
  "dashboard.tabs.whatsapp": "المحادثات",
  "dashboard.quickInfo.plan": "الخطة",
  "dashboard.quickInfo.session": "الجلسة",
  "dashboard.quickInfo.csvRows": "صفوف CSV",
  "dashboard.quickInfo.blacklisted": "محظور",
  "dashboard.toast.disconnected": "انقطع اتصال واتساب. جاري إعادة المسح...",
  "dashboard.quickInfo.title": "معلومات سريعة",

  // StatsCards
  "stats.totalUsage": "إجمالي الاستخدام",
  "stats.averageUsage": "متوسط الاستخدام عبر جميع الموارد",
  "stats.trendingUp": "استخدامك الإجمالي في ارتفاع. فكر في الترقية قريباً.",
  "stats.trendingDown": "استخدامك الإجمالي في انخفاض.",
  "stats.trendingFlat": "استخدامك الإجمالي مستقر.",
  "stats.exceededLimit": " لقد تجاوزت حد خطتك في بعض الموارد. ",
  "stats.upgradePrompt": "قم بترقية خطتك لزيادة الحدود.",
  "stats.messages": "الرسائل",
  "stats.usedMessages": "الرسائل المستخدمة",
  "stats.tokens": "الرموز",
  "stats.inputTokens": "الرموز المدخلة",
  "stats.outputTokens": "الرموز المخرجة",
  "stats.of": "من",
  "stats.usageStatistics": "إحصائيات الاستخدام",
  "stats.last7Days": "اتجاه آخر 7 أيام",

  // ChatListSidebar
  "chatList.title": "المحادثات",
  "chatList.bulkMessage": "رسالة جماعية",
  "chatList.crmPipeline": "مسار العملاء",
  "chatList.refreshChats": "تحديث المحادثات",
  "chatList.searchPlaceholder": "ابحث أو ابدأ محادثة جديدة",
  "chatList.filterAll": "الكل",
  "chatList.filterUnread": "غير مقروء",
  "chatList.filterGroups": "المجموعات",
  "chatList.tryAgain": "حاول مرة أخرى",
  "chatList.noChats": "لا توجد محادثات بعد",
  "chatList.you": "أنت",
  "chatList.yesterday": "أمس",
  "chatList.archived": "المؤرشفة",
  "chatList.noArchivedChats": "لا توجد محادثات مؤرشفة",
  "chatList.igConnectionAlert": "تنبيه بخصوص ربط انستجرام",
  "chatList.errorLoadingChats": "خطأ في تحميل المحادثات",
  "chatList.reconnectInstagram": "تحديث الرمز / إعادة الربط",
  "chatList.photo": "صورة",
  "chatList.video": "فيديو",
  "chatList.voiceMessage": "رسالة صوتية",
  "chatList.audio": "صوت",
  "chatList.document": "مستند",
  "chatList.location": "موقع",
  "chatList.sticker": "ملصق",
  "chatList.contact": "جهة اتصال",
  "chatList.poll": "استطلاع",
  "chatList.gif": "GIF",
  "chatList.product": "منتج",
  "chatList.call": "مكالمة",
  "chatList.catalog": "كتالوج",
  "chatList.order": "طلب",
  "chatList.template": "قالب",
  "chatList.button": "زر",
  "chatList.interactiveMessage": "رسالة تفاعلية",
  "chatList.disappearingMessage": "رسالة مؤقتة",
  "chatList.groupEvent": "حدث مجموعة",
  "chatList.notification": "إشعار",
  "chatList.broadcast": "بث",
  "chatList.typing": "يكتب الآن...",
  "chatList.recordingAudio": "يسجل رسالة صوتية...",

  // ChatWindow
  "chatWindow.title": "محادثة واتساب",
  "chatWindow.titleInstagram": "محادثات انستجرام Direct",
  "chatWindow.titleFacebook": "محادثات فيسبوك ماسنجر",
  "chatWindow.titleAll": "المحادثات الموحدة",
  "chatWindow.emptyText": "اختر محادثة من القائمة لبدء الدردشة. الرسائل تحدث في الوقت الفعلي.",
  "chatWindow.group": "مجموعة",
  "chatWindow.business": "تجاري",
  "chatWindow.refreshMessages": "تحديث الرسائل",
  "chatWindow.today": "اليوم",
  "chatWindow.yesterday": "أمس",
  "chatWindow.noMessages": "لا توجد رسائل بعد",
  "chatWindow.startConversation": "أرسل رسالة لبدء المحادثة",
  "chatWindow.back": "رجوع",
  "chatWindow.typing": "يكتب الآن...",
  "chatWindow.recordingAudio": "يسجل رسالة صوتية...",
  "chatWindow.viewContactSummary": "عرض معلومات جهة الاتصال والملخص",
  "chatWindow.smartSummary": "ملخص المحادثة الذكي",
  "chatWindow.summary": "ملخص",
  "contactDrawer.generatingSummary": "جاري قراءة الرسائل وتوليد الملخص...",
  "contactDrawer.noSummaryYet": "لا يوجد ملخص مولد حتى الآن لهذه المحادثة",
  "contactDrawer.generate": "توليد",
  "contactDrawer.done": "تم",

  // ChatInput
  "chatInput.aiReplying": "الذكاء الاصطناعي يولد رداً...",
  "chatInput.replying": "جاري الرد...",
  "chatInput.shareLocation": "مشاركة الموقع",
  "chatInput.locationName": "اسم الموقع *",
  "chatInput.address": "العنوان",
  "chatInput.latitude": "خط العرض *",
  "chatInput.longitude": "خط الطول *",
  "chatInput.sending": "جاري الإرسال...",
  "chatInput.sendLocation": "إرسال الموقع",
  "chatInput.shareLink": "مشاركة رابط",
  "chatInput.url": "الرابط *",
  "chatInput.captionOptional": "تعليق (اختياري)",
  "chatInput.sendLink": "إرسال الرابط",
  "chatInput.recordVoice": "تسجيل صوتي",
  "chatInput.attach": "مرفقات",
  "chatInput.aiAssistantPrompt": "كتابة رد بالذكاء الاصطناعي",
  "chatInput.typeMessage": "اكتب رسالة",
  "chatInput.locationUnavailable": "خاصية تحديد الموقع غير مدعومة في متصفحك",
  "chatInput.locationPermissionDenied": "يرجى تفعيل إذن الموقع الجغرافي (Location Permission) في المتصفح",
  "chatInput.liveLocationTitle": "📍 موقعي الحالي (Live Location)",

  // WhatsAppSessionPanel
  "wpp.readyToConnect": "جاهز للاتصال",
  "wpp.generatingToken": "جاري إنشاء الرمز...",
  "wpp.tokenGenerated": "تم إنشاء الرمز",
  "wpp.startingSession": "جاري بدء الجلسة...",
  "wpp.waitingForQR": "في انتظار مسح QR",
  "wpp.sessionConnected": "الجلسة متصلة",
  "wpp.connectionError": "خطأ في الاتصال",
  "wpp.stepToken": "الرمز",
  "wpp.stepQR": "كود QR",
  "wpp.stepConnected": "متصل",
  "wpp.noSession": "لا توجد جلسة متاحة. الرجاء تسجيل الدخول أولاً.",
  "wpp.title": "جلسة واتساب",
  "wpp.sessionLabel": "الجلسة:",
  "wpp.statusConnected": "متصل",
  "wpp.statusWaiting": "في الانتظار",
  "wpp.statusGenerating": "جاري التوليد",
  "wpp.statusStarting": "جاري البدء",
  "wpp.statusChecking": "جاري الفحص",
  "wpp.reset": "إعادة تعيين",
  "wpp.connectPrompt": "قم بإنشاء رمز وابدأ جلسة واتساب لتوصيل رقمك.",
  "wpp.connectBtn": "توصيل واتساب",
  "wpp.generatingDesc": "جاري إنشاء رمز آمن...",
  "wpp.generatingSub": "الاتصال بالخادم للمصادقة",
  "wpp.startingDesc": "جاري بدء جلسة واتساب...",
  "wpp.startingSub": "تهيئة الاتصال",
  "wpp.tokenReady": "تم إنشاء الرمز بنجاح",
  "wpp.startSession": "بدء الجلسة",
  "wpp.scanTitle": "امسح باستخدام واتساب",
  "wpp.scanDesc": "افتح واتساب على هاتفك، اذهب إلى <strong>الإعدادات &gt; الأجهزة المرتبطة</strong>، وامسح كود QR هذا.",
  "wpp.checkNow": "تحقق الآن",
  "wpp.startOver": "البدء من جديد",
  "wpp.autoCheck": "جاري التحقق التلقائي كل 5 ثوانٍ...",
  "wpp.connectedTitle": "واتساب متصل",
  "wpp.connectedDesc": "جلستك {{name}} نشطة وجاهزة.",
  "wpp.verifyConnection": "التحقق من الاتصال",
  "wpp.errorTitle": "خطأ",

  // AutomationPanel
  "automation.title": "إعدادات الأتمتة",
  "automation.subtitle": "تهيئة الردود الذكية بالذكاء الاصطناعي وجداول العمل والردود التلقائية.",
  "automation.statusUpdated": "تم تحديث الحالة!",
  "automation.failedUpdate": "فشل التحديث",
  "automation.statusTitle": "حالة الأتمتة",
  "automation.statusActive": "البوت يرد تلقائياً على الرسائل",
  "automation.statusPaused": "البوت متوقف مؤقتاً حالياً",
  "automation.lastUpdated": "آخر تحديث:",
  "automation.replySettings": "إعدادات الرد",
  "automation.replySettingsUpdated": "تم تحديث إعدادات الرد!",
  "automation.voiceMessages": "الرسائل الصوتية",
  "automation.voiceDesc": "رد تلقائي برسائل صوتية",
  "automation.imageReplies": "الردود بالصور",
  "automation.imageDesc": "رد تلقائي بالصور",
  "automation.documentReplies": "الردود بالمستندات",
  "automation.documentDesc": "رد تلقائي بالمستندات",
  "automation.followupTitle": "المتابعة الذكية (Drip Follow-up)",
  "automation.followupDesc": "تذكير تلقائي للعميل إذا توقف عن الرد لزيادة المبيعات والحجوزات.",
  "automation.followupDelay": "موعد الإرسال بعد توقف الرد:",
  "automation.followupDelay6h": "بعد 6 ساعات",
  "automation.followupDelay12h": "بعد 12 ساعة",
  "automation.followupDelay24h": "بعد 24 ساعة",
  "automation.followupDelay48h": "بعد 48 ساعة",
  "automation.followupMessage": "رسالة المتابعة:",
  "automation.useTemplate": "استخدام نص مقترح",
  "automation.followupTagHint": "استخدم {name} لاستبداله باسم العميل",
  "automation.characters": "حرف",
  "automation.guardTitle": "حماية ذكية وضمان عدم الإزعاج:",
  "automation.guardDesc": "تُلغى المتابعة فوراً إذا رد العميل أو حجز موعداً، وتُرسل مرة واحدة فقط مجاناً بدون استهلاك أي توكنز.",
  "automation.followupActive": "المتابعة جاهزة ومفعلة",
  "automation.followupDisabled": "الميزة معطلة",
  "automation.previewTitle": "معاينة الرسالة للعميل:",
  "automation.sampleCustomer": "محمد",
  "automation.quietHoursTitle": "ساعات الهدوء (عدم الإزعاج)",
  "automation.quietHoursDesc": "إيقاف المتابعة ليلاً وإرسالها تلقائياً في الصباح",
  "automation.quietHoursFrom": "من الساعة:",
  "automation.quietHoursTo": "إلى الساعة:",
  "automation.saveFollowupBtn": "حفظ الإعدادات",
  "automation.followupSaved": "تم حفظ إعدادات المتابعة التلقائية بنجاح!",
  "automation.followupStatsSent": "تم إرسال {{count}} متابعة هذا الأسبوع",
  "automation.followupStatsPending": "({{count}} قيد الانتظار)",
  "automation.followupStatsActive": "المتابعة التلقائية نشطة وبانتظار الفرص",
  "automation.defaultFollowupMessage": "مساء الخير يا فندم، كنا بنطمن لو لسه عند حضرتك أي استفسار وتحت أمرك في أي وقت",
  "automation.quietHoursSummary": "الهدوء: من {{start}} حتى {{end}} ({{duration}} ساعة إيقاف)",
  "automation.quietHoursDefault": "الافتراضي التلقائي: من 10:00 م حتى 9:00 ص",
  "automation.resetDefault": "استعادة الافتراضي",
  "automation.periodPM": "م",
  "automation.periodAM": "ص",

  // KnowledgeBasePanel
  "kb.title": "قاعدة المعرفة والذكاء الاصطناعي",
  "kb.subtitle": "تخصيص هوية المنشأة وتدريب المساعد الذكي بما يناسب مجال عملك",
  "kb.facilityType": "نوع النشاط أو المنشأة",
  "kb.facilityTypeDesc": "اختر طبيعة نشاطك لتكييف أقسام قاعدة المعرفة والـ AI تلقائياً",
  "kb.facility.ecommerce": "متاجر وتجارة إلكترونية",
  "kb.facility.ecommerceDesc": "منتجات، أسعار، مواصفات، مخزون، وسياسات الشحن",
  "kb.facility.agency": "وكالات وشركات خدمات",
  "kb.facility.agencyDesc": "خدمات رقمية، باقات تسويقية، نطاق العمل، واستشارات",
  "kb.facility.gym": "نوادي رياضية وجيمات",
  "kb.facility.gymDesc": "باقات اشتراك، تدريب خاص، مواعيد العمل، والمرافق",
  "kb.facility.clinic": "عيادات ومراكز طبية",
  "kb.facility.clinicDesc": "تخصصات، أطباء، مواعيد، وأسعار الكشوفات والخدمات",
  "kb.facility.restaurant": "مطاعم وكافيهات",
  "kb.facility.restaurantDesc": "منيو ووجبات، أسعار، فروع، وخدمة التوصيل",
  "kb.facility.realestate": "عقارات واستشارات",
  "kb.facility.realestateDesc": "وحدات ومشاريع، مساحات، أنظمة سداد، ومواقع",
  "kb.facility.custom": "نشاط مخصص (عام)",
  "kb.facility.customDesc": "تخصيص كامل لأي قطاع أو نشاط تجاري آخر",

  "kb.facility.ecommerce.singular": "منتج",
  "kb.facility.ecommerce.plural": "المنتجات والمخزون",
  "kb.facility.ecommerce.field.name.label": "اسم المنتج",
  "kb.facility.ecommerce.field.name.placeholder": "اكتب اسم المنتج وموديله (مثال: سماعات بلوتوث لاسلكية برو X200)",
  "kb.facility.ecommerce.field.category.label": "القسم / الفئة",
  "kb.facility.ecommerce.field.category.placeholder": "القسم أو الفئة التابع لها (مثال: إلكترونيات، ملابس رجالي، عناية بالبشرة)",
  "kb.facility.ecommerce.field.price.label": "السعر",
  "kb.facility.ecommerce.field.price.placeholder": "السعر والعملة وقيمة الخصم (مثال: 450 ج.م بدلاً من 600 ج / 99 ر.س)",
  "kb.facility.ecommerce.field.stock.label": "حالة المخزون",
  "kb.facility.ecommerce.field.stock.placeholder": "حالة توفر المنتج في المخزن (مثال: متوفر فوراً، نفد من المخزون، متاح للحجز المسبق)",
  "kb.facility.ecommerce.field.description.label": "الوصف والمواصفات",
  "kb.facility.ecommerce.field.description.placeholder": "مواصفات المنتج ومميزاته ومقاساته أو ألوانه (مثال: بطارية تدوم 24 ساعة، عزل ضوضاء، متاح بألوان أسود وأبيض)",
  "kb.facility.ecommerce.field.url.label": "رابط المنتج / المتجر",
  "kb.facility.ecommerce.field.url.placeholder": "رابط صفحة الشراء المباشر أو المعاينة (مثال: https://yourstore.com/item-123)",

  "kb.facility.agency.singular": "خدمة / باقة",
  "kb.facility.agency.plural": "الخدمات والباقات التسويقية",
  "kb.facility.agency.field.name.label": "اسم الخدمة أو الباقة",
  "kb.facility.agency.field.name.placeholder": "اسم الخدمة أو الباقة التسويقية (مثال: إدارة الحملات الإعلانية الممولة / باقة الهوية البصرية)",
  "kb.facility.agency.field.category.label": "مجال الخدمة",
  "kb.facility.agency.field.category.placeholder": "مجال وتخصص الخدمة (مثال: إعلانات ممولة، سيو وتصدر محركات البحث، برمجة وتطوير)",
  "kb.facility.agency.field.price.label": "سعر الخدمة / الميزانية التقديرية",
  "kb.facility.agency.field.price.placeholder": "تكلفة الخدمة أو الميزانية التقديرية (مثال: تبدأ من 5000 ج.م شهرياً / حسب حجم العمل)",
  "kb.facility.agency.field.timeline.label": "مدة التنفيذ والتسليم",
  "kb.facility.agency.field.timeline.placeholder": "المدة المتوقعة للتنفيذ والتسليم (مثال: من 7 إلى 10 أيام عمل / اشتراك تعاقدي شهري مستمر)",
  "kb.facility.agency.field.deliverables.label": "المخرجات ونطاق العمل بالتفصيل",
  "kb.facility.agency.field.deliverables.placeholder": "مخرجات ونطاق العمل المشمول في الباقة (مثال: إعداد الحملة، كتابة المحتوى، تصميم 12 إعلان، تقرير أداء أسبوعي)",
  "kb.facility.agency.field.portfolio_link.label": "رابط النماذج وسابقة الأعمال",
  "kb.facility.agency.field.portfolio_link.placeholder": "رابط نماذج أعمالك وسابقة المشروعات (مثال: https://agency.com/case-studies)",

  "kb.facility.gym.singular": "باقة اشتراك / برنامج",
  "kb.facility.gym.plural": "باقات الاشتراكات والبرامج الرياضية",
  "kb.facility.gym.field.name.label": "اسم الباقة أو الاشتراك",
  "kb.facility.gym.field.name.placeholder": "اسم باقة الاشتراك الرياضية (مثال: اشتراك بلاتينيوم 3 شهور / باقة التدريب الخاص VIP)",
  "kb.facility.gym.field.duration.label": "المدة والصلاحية",
  "kb.facility.gym.field.duration.placeholder": "مدة الباقة وصلاحية الاستخدام (مثال: شهر واحد / 3 شهور / سنة كاملة)",
  "kb.facility.gym.field.price.label": "سعر الاشتراك",
  "kb.facility.gym.field.price.placeholder": "قيمة الاشتراك شاملة الضريبة (مثال: 900 ج.م / 250 ر.س)",
  "kb.facility.gym.field.trainer_included.label": "التدريب الخاص والمتابعة",
  "kb.facility.gym.field.trainer_included.placeholder": "هل تشمل مدرباً شخصياً أو قياسات؟ (مثال: تشمل 8 جلسات تدريب خاص + قياس InBody شهرياً)",
  "kb.facility.gym.field.features.label": "المميزات والمرافق المشمولة",
  "kb.facility.gym.field.features.placeholder": "المرافق والأنشطة المشمولة في الاشتراك (مثال: دخول غير محدود لصالة الحديد، ساونا، جاكوزي، حصص فتنس جماعية)",

  "kb.facility.clinic.singular": "طبيب / خدمة طبية",
  "kb.facility.clinic.plural": "الأطباء والخدمات الطبية",
  "kb.facility.clinic.field.name.label": "اسم الطبيب أو الخدمة الطبية",
  "kb.facility.clinic.field.name.placeholder": "اسم الطبيب وتخصصه الدقيق (مثال: د. حسام الدين (استشاري جراحة وتجميل الأسنان))",
  "kb.facility.clinic.field.specialty.label": "التخصص الطبي / العيادة",
  "kb.facility.clinic.field.specialty.placeholder": "القسم الطبي أو نوع العيادة (مثال: طب الأسنان، جلدية وليزر، باطنة، أطفال)",
  "kb.facility.clinic.field.fee.label": "سعر الكشف / الاستشارة",
  "kb.facility.clinic.field.fee.placeholder": "سعر الكشف والاستشارة وميعاد الإعادة (مثال: 350 ج.م يشمل استشارة مجانية خلال 14 يوماً)",
  "kb.facility.clinic.field.schedule.label": "أيام وساعات التواجد",
  "kb.facility.clinic.field.schedule.placeholder": "مواعيد وأيام تواجد الطبيب بالعيادة (مثال: السبت والإثنين والأربعاء من 5 إلى 9 مساءً)",
  "kb.facility.clinic.field.bio.label": "النبذة الطبية والمؤهلات",
  "kb.facility.clinic.field.bio.placeholder": "المؤهلات العلمية والخبرات السابقة (مثال: دكتوراه جراحة الفم والأسنان، عضو الجمعية الأمريكية لزراعة الأسنان)",

  "kb.facility.restaurant.singular": "صنف / وجبة",
  "kb.facility.restaurant.plural": "أصناف وقائمة الطعام (المنيو)",
  "kb.facility.restaurant.field.name.label": "اسم الصنف أو الوجبة",
  "kb.facility.restaurant.field.name.placeholder": "اسم الصنف أو الوجبة في المنيو (مثال: برجر دبل تشيز أنجوس كلاسيك / بيتزا مارجريتا إيطالية)",
  "kb.facility.restaurant.field.category.label": "القسم في المنيو",
  "kb.facility.restaurant.field.category.placeholder": "القسم في قائمة الطعام (مثال: برجر، بيتزا، مشويات، مقبلات، حلويات، مشروبات)",
  "kb.facility.restaurant.field.price.label": "السعر",
  "kb.facility.restaurant.field.price.placeholder": "سعر الوجبة أو الحجم الأساسي (مثال: 140 ج.م / 35 ر.س)",
  "kb.facility.restaurant.field.ingredients.label": "المكونات والوصف",
  "kb.facility.restaurant.field.ingredients.placeholder": "المكونات وإرشادات الحساسية (مثال: 200 جرام لحم أنجوس مشوي، جبن شيدر ذائب، صوص خاص، خس وطماطم)",
  "kb.facility.restaurant.field.size_or_options.label": "الأحجام والإضافات المتاحة",
  "kb.facility.restaurant.field.size_or_options.placeholder": "الأحجام والإضافات المتاحة (مثال: عادي / كومبو مع بطاطس ومشروب بـ 30 ج / إضافة جبن إضافي)",

  "kb.facility.realestate.singular": "وحدة / مشروع",
  "kb.facility.realestate.plural": "الوحدات والمشاريع العقارية",
  "kb.facility.realestate.field.name.label": "اسم الوحدة أو المشروع",
  "kb.facility.realestate.field.name.placeholder": "اسم الوحدة العقارية أو المشروع (مثال: شقة دوبلكس كمبوند زيد / فيلا مستقلة بالم هيلز)",
  "kb.facility.realestate.field.type.label": "نوع العقار",
  "kb.facility.realestate.field.type.placeholder": "نوع العقار والغرض منه (مثال: شقة سكنية، تاون هاوس، فيلا مستقلة، مكتب إداري، محل تجاري)",
  "kb.facility.realestate.field.area.label": "المساحة والتقسيم",
  "kb.facility.realestate.field.area.placeholder": "المساحة والتقسيم الداخلي (مثال: 185م² (3 غرف نوم + 2 حمام + ريسبشن كبير + تراس))",
  "kb.facility.realestate.field.price.label": "السعر الإجمالي أو المقدم",
  "kb.facility.realestate.field.price.placeholder": "السعر الإجمالي أو قيمة المقدم (مثال: 3,500,000 ج.م (مقدم 10% = 350,000 ج))",
  "kb.facility.realestate.field.payment_plan.label": "نظام التقسيط والسداد",
  "kb.facility.realestate.field.payment_plan.placeholder": "نظام التقسيط وسنوات السداد (مثال: تقسيط حتى 8 سنوات بدون فوائد وأقساط متساوية)",
  "kb.facility.realestate.field.location.label": "الموقع والمنطقة",
  "kb.facility.realestate.field.location.placeholder": "الموقع والمنطقة والمعالم القريبة (مثال: التجمع الخامس، المربع الذهبي - بالقرب من الجامعة الأمريكية)",
  "kb.facility.realestate.field.features.label": "المميزات وموعد الاستلام",
  "kb.facility.realestate.field.features.placeholder": "المميزات وموعد الاستلام والتشطيب (مثال: إطلالة بحيرات، جراج خاص، أمن 24 ساعة، استلام بعد سنتين تشطيب كامل)",

  "kb.facility.custom.singular": "عنصر / خدمة",
  "kb.facility.custom.plural": "العناصر والبيانات المخصصة",
  "kb.facility.custom.field.name.label": "الاسم أو العنوان",
  "kb.facility.custom.field.name.placeholder": "اسم العنصر أو الخدمة أو المعلومة (مثال: باقة الصيانة الدورية / استشارة فنية / اشتراك VIP)",
  "kb.facility.custom.field.category.label": "النوع / التصنيف",
  "kb.facility.custom.field.category.placeholder": "التصنيف أو القسم التابع له (مثال: خدمات عامة، استشارات، منتجات خاصة)",
  "kb.facility.custom.field.price.label": "السعر / التكلفة (إن وجد)",
  "kb.facility.custom.field.price.placeholder": "السعر أو التكلفة إن وجدت (مثال: 500 ج.م / مجاناً للعملاء / حسب المتطلبات)",
  "kb.facility.custom.field.description.label": "التفاصيل والشرح الشامل",
  "kb.facility.custom.field.description.placeholder": "شرح تفصيلي كامل يوضح كل ما يخص هذا العنصر للعملاء (مثال: تشمل هذه الخدمة فحص كامل مع تقرير فني معتمد)",
  "kb.facility.custom.field.link.label": "رابط إضافي أو صفحة تفاصيل",
  "kb.facility.custom.field.link.placeholder": "رابط إضافي للمعاينة أو صفحة التفاصيل (مثال: https://yoursite.com/service-123)",

  "kb.profileSection": "الملف التعريفي للنشاط",
  "kb.profileDesc": "البيانات العامة للشركة وطرق التواصل وساعات العمل",
  "kb.catalogSection": "الكتالوج / الباقات والخدمات",
  "kb.catalogDesc": "العناصر التفصيلية والأسعار التي يجيب المساعد الذكي عنها",
  "kb.policySection": "السياسات والشروط والإرشادات",
  "kb.policyDesc": "شروط الخدمة، سياسات الاسترجاع، الحجز، ومعلومات إضافية",
  "kb.customSection": "حقول إضافية مخصصة",
  "kb.customDesc": "أضف أي معلومات أو بيانات مخصصة إضافية يرغب المساعد الذكي بمعرفتها",
  "kb.faq.title": "أسئلة استقبال العملاء",
  "kb.faq.description": "أنشئ الأسئلة التي يطرحها المساعد عند بدء حالة أو طلب محدد",
  "kb.faq.question": "سؤال المساعد للعميل",
  "kb.faq.answer": "إرشاد التعامل مع الإجابة",
  "kb.faq.topic": "متى يُسأل؟ / المحفّز",
  "kb.faq.add": "إضافة سؤال استقبال",
  "kb.faq.questionHint": "مثال: ما الشكوى الأساسية؟",
  "kb.faq.answerHint": "مثال: سجّل الإجابة ثم انتقل للسؤال التالي أو سلّمها للفريق",
  "kb.faq.topicHint": "مثال: عند طلب حجز أو الاستفسار عن خدمة معينة",
  "kb.faq.suggestions.clinic": "أنشئ نموذجًا منفصلًا لكل تخصص: أسنان، عيون، علاج طبيعي، جلدية…",
  "kb.faq.suggestions.gym": "العضويات، الحصص، التدريب والتجميد",
  "kb.faq.suggestions.restaurant": "التوصيل، الحساسية، الحجز والدفع",
  "kb.faq.suggestions.ecommerce": "الشحن، الإرجاع، المخزون والضمان",
  "kb.faq.suggestions.realestate": "المعاينات، خطط السداد والمستندات",
  "kb.faq.suggestions.agency": "النطاق، المدة، السعر والدعم",
  "kb.faq.suggestions.custom": "الأسعار، التوفر وطريقة البدء",

  "kb.importCsv": "استيراد",
  "kb.resetBtn": "إعادة تعيين",
  "kb.resetConfirmTitle": "إعادة تعيين قاعدة المعرفة؟",
  "kb.resetConfirmDesc": "سيتم مسح كافة الحقول والعناصر والبيانات المدخلة في النموذج لتتمكن من إدخال بيانات جديدة بالكامل من الصفر.",
  "kb.confirmReset": "تأكيد",
  "kb.cancel": "إلغاء",
  "kb.resetDone": "تم مسح البيانات بنجاح.",
  "kb.addItem": "إضافة",
  "kb.addCustomField": "إضافة",
  "kb.customKey": "اسم الحقل / المفتاح",
  "kb.customKeyPlaceholder": "اسم الخاصية (مثال: كود الخصم، مدة الضمان، الشحن الدولي)",
  "kb.customValue": "القيمة / المعلومة",
  "kb.customValuePlaceholder": "القيمة أو الشرح (مثال: خصم 10% بكود WYZON10، ضمان سنتين استبدال فوري)",
  "kb.removeCustomField": "حذف",
  "kb.submitCsv": "حفظ",
  "kb.submitting": "جاري الحفظ...",
  "kb.fillRequired": "يرجى ملء حقل واحد على الأقل قبل الحفظ",
  "kb.submitSuccess": "تم الحفظ بنجاح!",
  "kb.submitFailed": "فشل حفظ قاعدة المعرفة",
  "kb.fieldsFilled": "{{total}} حقل مدخل في {{sections}} أقسام",
  "kb.fieldsCount": "{{filled}}/{{total}} حقل",
  "kb.removeItem": "حذف",
  "kb.itemDefault": "عنصر {{index}}",

  // Subscription Lock Overlay
  "lock.badge": "ضمان وتشغيل Wyzon AI المعتمد",
  "lock.expiredTitle": "انتهت فترة اشتراكك الحالية",
  "lock.limitTitle": "نفد رصيد الاستهلاك الخاص بباقتك",
  "lock.expiredDesc": "اختر باقة تناسب حجم أعمالك لتجديد الاشتراك والاستمرار في الاستفادة من ردود الذكاء الاصطناعي وخدمات الواتساب.",
  "lock.limitDesc": "لقد استهلكت كامل رصيد الرسائل أو التوكينات المتاحة في خطتك. يرجى الترقية للاستمرار في الخدمة الفورية.",
  "lock.buyPlanBtn": "تجديد / شراء باقة الآن",
  "lock.contactSupportBtn": "التواصل مع الدعم الفني",
  "lock.card1.title": "تفاصيل الباقة والاستهلاك",
  "lock.card1.planName": "الباقة: {{name}}",
  "lock.card1.messages": "الرسائل: {{used}} / {{limit}} ({{percent}}%)",
  "lock.card1.expiredDate": "تاريخ الانتهاء: {{date}}",
  "lock.card1.upgrade": "ترقية الباقة الآن",
  "lock.card2.title": "المميزات والخدمات الذكية",
  "lock.card2.desc": "استمتع بالردود الصوتية الذكية (Voice Notes) وإرسال الصور والكتالوجات التفاعلية تلقائياً عبر الواتساب.",
  "lock.card2.link": "معرفة المزيد",
  "lock.card3.title": "دعم وتجهيز مخصص 24/7",
  "lock.card3.desc": "فريق الدعم الفني متاح لمساعدتك في تجهيز قاعدة المعرفة وربط حسابك وتخصيص البوت بما يناسب عملك.",
  "lock.card3.link": "تواصل معنا",

  // Base Profile Fields
  "kb.field.name": "اسم المنشأة أو النشاط",
  "kb.field.namePlaceholder": "اكتب الاسم الرسمي لنشاطك كما يعرفه عملاؤك (مثال: براند زاد للأزياء / عيادة د. أحمد / مطعم شاورما كينج)",
  "kb.field.industry": "المجال أو التخصص",
  "kb.field.industryPlaceholder": "حدد نشاطك أو مجالك بدقة (مثال: متجر ملابس وأحذية، عيادة أسنان، جيم ولياقة بدنية، تسويق رقمي)",
  "kb.field.description": "نبذة تعريفية شاملة",
  "kb.field.descriptionPlaceholder": "اشرح باختصار ما تقدمه شركتك، رسالتكم، وأهم ما يميزكم ليعتمد عليه المساعد الذكي في إقناع العملاء (مثال: متجر متخصص في... مع شحن سريع وضمان استبدال)",
  "kb.field.phone": "رقم الهاتف / الخط الساخن",
  "kb.field.phonePlaceholder": "رقم خدمة العملاء أو الواتساب المتاح للتواصل (مثال: 201012345678+ أو 19999)",
  "kb.field.email": "البريد الإلكتروني",
  "kb.field.emailPlaceholder": "البريد الرسمي للاستفسارات والمراسلات (مثال: info@yourbusiness.com)",
  "kb.field.website": "الموقع الإلكتروني",
  "kb.field.websitePlaceholder": "رابط موقعك الإلكتروني أو متجرك (مثال: https://yourbrand.com)",
  "kb.field.workingHours": "مواعيد وساعات العمل",
  "kb.field.workingHoursPlaceholder": "أيام وساعات العمل ومواعيد الاستقبال (مثال: يومياً من 10 ص حتى 10 م، الجمعة من 2 ظهراً)",
  "kb.field.address": "العنوان والموقع الفعلي",
  "kb.field.addressPlaceholder": "العنوان التفصيلي للفرع الرئيسي ومناطق التغطية (مثال: 15 شارع النصر، المعادي، القاهرة)",
  "kb.field.paymentMethods": "طرق الدفع المتاحة",
  "kb.field.paymentMethodsPlaceholder": "طرق الدفع والتحويل المقبولة (مثال: كاش عند الاستلام، فيزا/ماستركارد، فودافون كاش، إنستاباي، تابي)",
  "kb.field.valuePlaceholder": "أدخل {{field}}",
  "kb.field.warrantyPolicy": "سياسة الضمان",
  "kb.field.warrantyPolicyPlaceholder": "مدة الضمان وشروطه وطريقة الاستفادة منه",
  "kb.dynamicField.medical_specialties": "التخصصات الطبية المتاحة",
  "kb.dynamicField.booking_channels": "طرق الحجز المتاحة",
  "kb.dynamicField.emergency_contact": "رقم الطوارئ أو التواصل العاجل",
  "kb.dynamicField.fitness_focus": "مجالات التدريب واللياقة",
  "kb.dynamicField.cuisine_type": "نوع المأكولات",
  "kb.dynamicField.ordering_channels": "طرق الطلب المتاحة",
  "kb.dynamicField.customer_support_channels": "قنوات خدمة العملاء",
  "kb.dynamicField.service_areas": "نطاق ومناطق الخدمة",
  "kb.dynamicField.company_overview": "نبذة عن الشركة",

  // Facility-Specific Profile Fields
  "kb.field.shippingPolicy": "سياسة الشحن والتوصيل",
  "kb.field.shippingPolicyPlaceholder": "وضح مدة الشحن، المحافظات، ورسوم التوصيل (مثال: التوصيل خلال 2-4 أيام، مجاني للطلبات فوق 500 ج، الشحن لكافة المحافظات)",
  "kb.field.returnPolicy": "سياسة الاستبدال والاسترجاع",
  "kb.field.returnPolicyPlaceholder": "شروط الاستبدال والاسترجاع للمنتجات (مثال: متاح استبدال أو استرجاع مجاني خلال 14 يوماً من الاستلام بشرط سلامة الغلاف الأصلي)",
  "kb.field.targetAudience": "القطاعات والعملاء المستهدفون",
  "kb.field.targetAudiencePlaceholder": "حدد طبيعة عملائك المستهدفين (مثال: الشركات الناشئة، المتاجر الإلكترونية، العيادات والمراكز الطبية)",
  "kb.field.paymentTerms": "شروط التعاقد والدفع",
  "kb.field.paymentTermsPlaceholder": "نظام المراحل والدفعات المالية (مثال: 50% دفعة مقدمة لبدء التنفيذ، و50% عند الاعتماد النهائي والتسليم)",
  "kb.field.genderSchedule": "مواعيد السيدات / الرجال",
  "kb.field.genderSchedulePlaceholder": "مواعيد الفترات المخصصة للسيدات والرجال (مثال: فترات السيدات يومياً من 10 ص إلى 2 م، وباقي اليوم فترات مختلطة)",
  "kb.field.amenities": "المرافق والأجهزة المتاحة",
  "kb.field.amenitiesPlaceholder": "المرافق والخدمات المتاحة للمشتركين (مثال: صالة حديد وكارديو حديثة، ساونا، جاكوزي، غرف ملابس، لوكر شخصي، واي فاي)",
  "kb.field.gymRules": "قواعد وشروط النادي",
  "kb.field.gymRulesPlaceholder": "إرشادات الملابس وسياسة التجميد (مثال: مسموح تجميد الاشتراك لمرة واحدة بحد أقصى شهر، الالتزام بالزي الرياضي وحذاء مخصص)",
  "kb.field.bookingInstructions": "طريقة وتعليمات الحجز",
  "kb.field.bookingInstructionsPlaceholder": "كيفية تأكيد الموعد وإرشادات الحضور (مثال: الحجز المسبق مطلوب عبر الواتساب أو الهاتف، يرجى الحضور قبل الموعد بـ 15 دقيقة)",
  "kb.field.emergencyInfo": "الطوارئ والخط الساخن",
  "kb.field.emergencyInfoPlaceholder": "أرقام الطوارئ المتاحة على مدار الساعة (مثال: الخط الساخن 19000 أو واتساب الطوارئ +201100000000)",
  "kb.field.insuranceAccepted": "شركات التأمين المعتمدة",
  "kb.field.insuranceAcceptedPlaceholder": "قائمة شركات التأمين والشبكات الطبية المقبولة (مثال: أكسا، بوبا، كير بلس، متلايف، ميدنت، أليانز)",
  "kb.field.deliveryAreas": "مناطق التوصيل والحد الأدنى",
  "kb.field.deliveryAreasPlaceholder": "مناطق التغطية والحد الأدنى والرسوم (مثال: نوصل لكافة مناطق القاهرة والجيزة، الحد الأدنى للطلب 100 ج، خدمة التوصيل 25 ج)",
  "kb.field.branchesList": "الفروع والعناوين بالتفصيل",
  "kb.field.branchesListPlaceholder": "فروعكم وعناوينها (مثال: فرع مدينة نصر: 10 ش عباس العقاد / فرع المعادي: ش النصر بجوار البنك الأهلي)",
  "kb.field.dineInReservations": "حجز الطاولات والمناسبات",
  "kb.field.dineInReservationsPlaceholder": "سياسة حجز الطاولات وإقامة المناسبات (مثال: حجز الطاولات قبل الموعد بساعتين، إمكانية حجز قاعة أعياد الميلاد بحد أدنى 10 أفراد)",
  "kb.field.developerName": "اسم المطور العقاري أو الشركة المالكة",
  "kb.field.developerNamePlaceholder": "اسم المطور العقاري المنفذ للمشروع (مثال: مجموعة طلعت مصطفى / إعمار مصر / شركة سوديك)",
  "kb.field.bookingSteps": "أنظمة وخطوات التعاقد والحجز",
  "kb.field.bookingStepsPlaceholder": "خطوات الحجز والأوراق المطلوبة (مثال: دفع 50,000 ج جدية حجز قابلة للاسترداد، إحضار صورة بطاقة الرقم القومي سارية)",


  // BlacklistPanel
  "blacklist.title": "القائمة السوداء",
  "blacklist.addNumber": "إضافة رقم",
  "blacklist.phonePlaceholder": "أدخل رقم الهاتف (مثال: 201234567890)",
  "blacklist.block": "حظر",
  "blacklist.invalidPhone": "أدخل رقم هاتف صحيح (10-15 رقم، بدون +)",
  "blacklist.addedSuccess": "تم إضافة الرقم إلى القائمة السوداء بنجاح",
  "blacklist.addedFailed": "فشل إضافة الرقم، يرجى المحاولة مرة أخرى",
  "blacklist.removedSuccess": "تم إزالة الرقم من القائمة السوداء",
  "blacklist.removedFailed": "فشل إزالة الرقم",
  "blacklist.empty": "القائمة السوداء فارغة",
  "blacklist.emptyDesc": "جميع الأرقام والعملاء يمكنهم التواصل واستلام الردود التلقائية من البوت.",
  "blacklist.blockedCount": "الأرقام المحظورة: {{count}}",
  "blacklist.addTitle": "إضافة رقم جديد للحظر",
  "blacklist.addSubtitle": "اختر كود الدولة ثم اكتب رقم الهاتف بدون الصفر الأول.",
  "blacklist.searchCountry": "ابحث عن الدولة...",
  "blacklist.phonePlaceholderDynamic": "رقم الهاتف (مثال: {{example}})",
  "blacklist.validPhoneDigits": "يرجى إدخال رقم صحيح ({{digits}} أرقام)",
  "blacklist.alreadyBlacklisted": "هذا الرقم محظور بالفعل",
  "blacklist.currentNumbers": "الأرقام المحظورة حالياً ({{count}})",
  "blacklist.searchList": "بحث في القائمة...",
  "blacklist.noMatch": "لا توجد أرقام مطابقة لنتيجة البحث.",
  "blacklist.aiBlocked": "محظور من الرد الآلي",
  "blacklist.unblock": "إلغاء",
  "blacklist.country.20": "مصر",
  "blacklist.country.966": "السعودية",
  "blacklist.country.971": "الإمارات",
  "blacklist.country.965": "الكويت",
  "blacklist.country.974": "قطر",
  "blacklist.country.973": "البحرين",
  "blacklist.country.968": "عُمان",
  "blacklist.country.962": "الأردن",
  "blacklist.country.961": "لبنان",
  "blacklist.country.964": "العراق",
  "blacklist.country.967": "اليمن",
  "blacklist.country.970": "فلسطين",
  "blacklist.country.218": "ليبيا",
  "blacklist.country.216": "تونس",
  "blacklist.country.213": "الجزائر",
  "blacklist.country.212": "المغرب",
  "blacklist.country.249": "السودان",
  "blacklist.country.1": "أمريكا / كندا",
  "blacklist.country.44": "بريطانيا",
  "blacklist.country.49": "ألمانيا",
  "blacklist.country.33": "فرنسا",
  "blacklist.country.90": "تركيا",
  "blacklist.country.963": "سوريا",
  "blacklist.country.91": "الهند",

  // BulkMessagingPanel
  "bulk.title": "الرسائل الجماعية",
  "bulk.messageComposer": "محرر الرسالة",
  "bulk.simple": "بسيط",
  "bulk.advanced": "متقدم",
  "bulk.messagePlaceholder": "مرحباً {{name}}! لدينا عرض حصري لك...",
  "bulk.charCount": "{{{count}}} / 4096",
  "bulk.insertVariables": "أدخل متغيرات ديناميكية لتخصيص الرسائل",
  "bulk.name": "الاسم",
  "bulk.phone": "الهاتف",
  "bulk.attach": "مرفقات",
  "bulk.delayTitle": "التأخير بين الرسائل",
  "bulk.delayDesc": "يقلل من خطر اكتشاف البريد العشوائي. موصى به: 5-15 ثانية",
  "bulk.sec": "ثانية",
  "bulk.randomDelay": "تأخير عشوائي",
  "bulk.scheduleTitle": "جدولة الإرسال",
  "bulk.date": "التاريخ",
  "bulk.time": "الوقت",
  "bulk.campaignScheduled": "تمت جدولة الحملة",
  "bulk.preview": "معاينة",
  "bulk.previewEmpty": "ستظهر رسالتك هنا...",
  "bulk.justNow": "الآن",
  "bulk.contacts": "جهات الاتصال",
  "bulk.contactsFormat": "صيغة الهاتف، الاسم",
  "bulk.importCsv": "استيراد CSV",
  "bulk.clearAll": "مسح الكل",
  "bulk.sendAll": "إرسال الكل",
  "bulk.stopSending": "إيقاف الإرسال",
  "bulk.scheduleSend": "جدولة الإرسال",
  "bulk.sendingMessages": "جاري إرسال الرسائل...",
  "bulk.noContacts": "لا توجد جهات اتصال",
  "bulk.importPrompt": "استورد CSV أو قم بتوصيل واتساب لتحميل جهات الاتصال",
  "bulk.scheduledBanner": "يبدأ الإرسال {{date}}، {{time}}",
  "bulk.recipientsWillReceive": "{{count}} جهة اتصال{{plural}} ستستلم الرسالة",
  "bulk.cancel": "إلغاء",
  "bulk.all": "الكل",
  "bulk.channelAll": "الكل",
  "bulk.channelWhatsapp": "واتساب",
  "bulk.channelMessenger": "ماسنجر",
  "bulk.platformColumn": "القناة",
  "bulk.messengerId": "معرّف ماسنجر",
  "bulk.filterByChannel": "تصفية القنوات",
  "bulk.pending": "قيد الانتظار",
  "bulk.sent": "تم الإرسال",
  "bulk.failed": "فشل",
  "bulk.nameColumn": "الاسم",
  "bulk.phoneColumn": "الهاتف",
  "bulk.statusColumn": "الحالة",
  "bulk.backToChats": "العودة للمحادثات",
  "bulk.mobileTabMessage": "الرسالة",
  "bulk.mobileTabContacts": "جهات الاتصال",
  "bulk.csvImportSuccess": "تم استيراد {{count}} جهة{{plural}}",
  "bulk.csvDuplicates": "تم تخطي {{count}} مكرر{{plural}}",
  "bulk.csvNoPhone": "{{count}} صف{{plural}} بدون هاتف",
  "bulk.csvNoNew": "لم تتم إضافة جهات اتصال جديدة.",
  "bulk.csvInvalidType": "نوع ملف غير صالح. الرجاء رفع ملف .csv.",
  "bulk.csvTooLarge": "الملف كبير جداً ({{size}}ميجابايت). الحد الأقصى 5 ميجابايت.",
  "bulk.csvReadError": "فشل قراءة الملف. تأكد أنه ملف CSV صالح.",
  "bulk.csvNoData": "لم يتم العثور على صفوف بيانات صالحة في الملف.",
  "bulk.csvNoHeaders": "لم يتم العثور على عناوين صالحة.",
  "bulk.csvHeadersOnly": "الملف يحتوي على عناوين فقط — لا توجد صفوف بيانات.",
  "bulk.csvColumnMismatch": "صف {{row}}: متوقع {{expected}} عمود، تم استلام {{got}}. تم تخطي الصف.",
  "bulk.csvEmpty": "الملف فارغ.",
  "bulk.pagination": "{{start}}-{{end}} من {{total}}",
  "bulk.scheduleTimeFuture": "يجب أن يكون وقت الجدولة في المستقبل.",
  "bulk.failedToSend": "فشل إرسال الرسالة",
  "bulk.switchFixedDelay": "تبديل للتأخير الثابت",
  "bulk.switchRandomDelay": "تبديل للتأخير العشوائي",
  "bulk.switchSendNow": "تبديل للإرسال الفوري",
  "bulk.switchSchedule": "تفعيل جدولة الإرسال",
  "bulk.cancelSchedule": "إلغاء الجدولة",
  "bulk.stopSendingTooltip": "إيقاف الإرسال",
  "bulk.mobileRecipients": "{{{count}}} جهة - {{{status}}}",
  "bulk.statusPending": "قيد الانتظار",
  "bulk.statusSent": "تم الإرسال",
  "bulk.statusFailed": "فشل",

  // MessageBubble
  "msg.photo": "صورة",
  "msg.video": "فيديو",
  "msg.audio": "صوت",
  "msg.voiceMessage": "رسالة صوتية",
  "msg.document": "مستند",
  "msg.location": "موقع جغرافي",
  "msg.sticker": "ملصق",
  "msg.contact": "جهة اتصال",
  "msg.link": "رابط",
  "msg.deleted": "تم حذف هذه الرسالة",
  "msg.you": "أنت",
  "msg.loadingImage": "جاري تحميل الصورة...",
  "msg.imageUnavailable": "الصورة غير متاحة",
  "msg.image": "صورة",
  "msg.loadingVideo": "جاري تحميل الفيديو...",
  "msg.videoUnavailable": "الفيديو غير متاح",
  "msg.tapToOpenMap": "اضغط لفتح الخريطة",
  "msg.openInMaps": "فتح في الخرائط",
  "msg.file": "ملف",
  "msg.documentType": "مستند",
  "msg.voiceCall": "مكالمة صوتية",
  "msg.videoCall": "مكالمة فيديو",
  "msg.tapToCallBack": "اضغط للاتصال مرة أخرى",
  "msg.contactCard": "بطاقة جهة اتصال",
  "msg.transcriptionFailed": "تعذر تفريغ الصوت",
  "msg.decryptFailed": "تعذر تحميل المقطع الصوتي لتفريغه",
  "msg.viewTranscript": "عرض النص",

  // MessageActions
  "actions.reply": "رد",
  "actions.aiReply": "اقترح رد ذكي",
  "actions.generatingSuggestion": "جاري صياغة الرد المقترح...",
  "actions.sendNow": "إرسال الآن",
  "actions.insertInEditor": "تعديل في المحرر",
  "actions.transcribe": "تفريغ",
  "actions.copy": "نسخ",
  "actions.react": "تفاعل",
  "actions.cancel": "إلغاء",

  // AttachmentMenu
  "attach.aiAssistant": "صياغة رسالة ذكية",
  "attach.image": "صورة",
  "attach.document": "مستند",
  "attach.location": "موقع",
  "attach.link": "رابط",

  // VoiceRecorder
  "voice.delete": "حذف",
  "voice.connecting": "جاري الاتصال...",
  "voice.resume": "استئناف",
  "voice.pause": "إيقاف",
  "voice.send": "إرسال",

  // ReplyPreview
  "reply.replyTo": "الرد على",

  // CsvProductImporter
  "csvImporter.title": "استيراد المنتجات عبر CSV",
  "csvImporter.subtitle": "استيراد دفعة من المنتجات إلى قاعدة المعرفة",
  "csvImporter.expectedColumns": "الأعمدة المتوقعة",
  "csvImporter.column": "العمود",
  "csvImporter.required": "مطلوب",
  "csvImporter.optional": "اختياري",
  "csvImporter.example": "مثال",
  "csvImporter.requiredBadge": "مطلوب",
  "csvImporter.optionalBadge": "اختياري",
  "csvImporter.validationTitle": "قواعد التحقق",
  "csvImporter.valRequired": "اسم المنتج ووصف المنتج <strong>مطلوبان</strong> — سيتم تخطي الصفوف التي تفتقر إليهما",
  "csvImporter.valEmptyRows": "يتم تجاهل الصفوف الفارغة تلقائياً",
  "csvImporter.valPrice": "يجب أن يكون السعر رقماً صالحاً (مثال: 299.99)",
  "csvImporter.valDuplicates": "يتم اكتشاف المنتجات المكررة (بالاسم) وتخطيها",
  "csvImporter.valEncoding": "يدعم ترميز UTF-8 للعربية واللغات الأخرى",
  "csvImporter.valTrim": "يتم إزالة المسافات الزائدة من بداية ونهاية كل حقل",
  "csvImporter.downloadTemplate": "تحميل قالب CSV نموذجي",
  "csvImporter.dropHere": "أسقط الملف هنا",
  "csvImporter.clickToUpload": "انقر للرفع أو اسحب وأفلت",
  "csvImporter.csvOnly": "ملفات CSV فقط، يوصى بترميز UTF-8",
  "csvImporter.processing": "جاري معالجة ملف CSV...",
  "csvImporter.validating": "التحقق من البيانات والبحث عن الأخطاء",
  "csvImporter.rowsRead": "صفوف مقروءة",
  "csvImporter.imported": "تم الاستيراد",
  "csvImporter.failed": "فشل",
  "csvImporter.errorsTitle": "أخطاء الاستيراد ({{count}})",
  "csvImporter.fileError": "ملف",
  "csvImporter.rowError": "صف {{row}}",
  "csvImporter.readyTitle": "منتجات جاهزة للاستيراد ({{count}})",
  "csvImporter.uploadAnother": "رفع ملف آخر",
  "csvImporter.cancel": "إلغاء",
  "csvImporter.importBtn": "استيراد {{count}} منتج{{plural}}",
  "csvImporter.invalidFileType": "نوع ملف غير صالح. الرجاء رفع ملف .csv.",
  "csvImporter.noHeaderColumns": "لم يتم التعرف على أعمدة منتجات في العنوان. يرجى التحقق من أسماء الأعمدة.",
  "csvImporter.missingRequiredCols": "يجب أن يتضمن ملف CSV على الأقل عمودي 'Product Name' و 'Product Description'.",
  "csvImporter.missingName": "اسم المنتج مطلوب ومفقود.",
  "csvImporter.missingDesc": "\"{{name}}\" يفتقد وصف المنتج، وهو مطلوب.",
  "csvImporter.invalidPrice": "\"{{name}}\" لديه سعر غير صالح: \"{{price}}\". يجب أن يكون رقماً صالحاً.",
  "csvImporter.duplicate": "\"{{name}}\" موجود بالفعل في قائمة المنتجات. تم تخطي المكرر.",
  "csvImporter.dupInCsv": "\"{{name}}\" يظهر عدة مرات في ملف CSV. تم تخطي المكرر.",
  "csvImporter.readFailed": "فشل قراءة الملف. تأكد أنه ملف CSV صالح بترميز UTF-8.",

  // Charts
  "charts.usageTrends": "اتجاهات الاستخدام",
  "charts.last30Days": "آخر 30 يوماً · الرموز والرسائل",
  "charts.tokens": "الرموز",
  "charts.messages": "الرسائل",
  "charts.input": "المدخلات",
  "charts.output": "المخرجات",
  "charts.tokenSplit": "توزيع الرموز",
  "charts.inputVsOutput": "توزيع المدخلات مقابل المخرجات",
  "charts.inputRatio": "نسبة المدخلات",
  "charts.planCapacity": "سعة الخطة",
  "charts.usageVsLimits": "الاستخدام مقابل الحدود لكل ميزة",
  "charts.used": "مستخدم",
  "charts.dailyActivity": "النشاط اليومي",
  "charts.inputOutputPerDay": "الرموز المدخلة والمخرجة يومياً",
  "charts.activityCalendar": "تقويم النشاط",
  "charts.activitySubtitle": "{{messages}} رسالة · {{days}} يوم نشط · آخر 4 أسابيع",
  "charts.less": "أقل",
  "charts.more": "أكثر",
  "charts.buildingHistory": "جاري بناء سجل النشاط",
  "charts.buildingHistoryDesc": "تتراكم البيانات في كل مرة تزور فيها لوحة التحكم. عد غداً لرؤية أول اتجاه لك!",
  "charts.activeDays": "الأيام النشطة",
  "charts.of28": "{{days}} من 28",
  "charts.avgDaily": "المتوسط اليومي",
  "charts.avgDailyMsgs": "{{msgs}} رسالة",
  "charts.system": "سياق النظام",
  "charts.inputPrompts": "مدخلات المحادثة",
  "charts.aiOutput": "مخرجات الذكاء",
  "charts.systemContext": "سياق النظام والذاكرة",
  "charts.avgHandleTime": "متوسط سرعة الاستجابة",
  "charts.minute": "دقيقة",
  "charts.vsLastWeek": "مقارنة بالأسبوع السابق",
  "charts.activitiesCount": "{{count}} نشاط",

  // Plan Usage
  "planUsage.messagesUsage": "استهلاك الرسائل",
  "planUsage.used": "مستهلك",
  "planUsage.upgradePlan": "ترقية الباقة",
  "planUsage.consumed": "المستهلك",
  "planUsage.remaining": "المتبقي",
  "planUsage.available": "المتاح",

  // Workflows
  "workflows.smartReplyUpdated": "تم تحديث إعدادات الردود الذكية بنجاح",
  "workflows.reengageDesc": "متابعة العملاء غير المتفاعلين تلقائياً واسترداد المبيعات",
  "workflows.sentThisWeek": "تم إرسال {{count}} متابعة هذا الأسبوع",
  "workflows.sentTotal": "تم إرسال {{count}} متابعة إجمالاً",
  "workflows.activeMonitoring": "المتابعة نشطة وبانتظار الفرص",
  "workflows.queuedPending": "({{count}} قيد الانتظار)",

  // Copilot Assistant
  "copilot.action.launchCampaign": "بدء حملة جماعية",
  "copilot.action.startCampaign": "بدء حملة",
  "copilot.action.chats": "المحادثات",
  "copilot.action.checkChats": "فحص المحادثات",
  "copilot.action.knowledge": "قاعدة المعرفة",
  "copilot.action.blacklist": "القائمة السوداء",
  "copilot.action.automation": "الأتمتة",
  "copilot.action.upgradePlan": "ترقية الباقة",
  "copilot.response.suggest": "تقدر تبدأ حملة رسائل جماعية لعملائك أو ترفع ملف تدريب للشات بوت في قاعدة المعرفة أو تتابع محادثات الواتساب الحية",
  "copilot.response.howAreYou": "الحمد لله تمام وتحت امرك تحب نعمل ايه النهاردة في المنصة",
  "copilot.response.greeting": "اهلا بيك جاهز اساعدك في اي حاجة في المنصة او حسابك",
  "copilot.response.thanks": "تسلم يا غالي في اي وقت انا في خدمتك",
  "copilot.response.quota": "باقي في رصيدك {{remaining}} رسالة من اجمالي {{total}} واستهلكت {{used}} على باقة {{plan}}",
  "copilot.response.whatsappConnected": "الواتساب متصل وشغال تمام ومستعد يستقبل ويرد على الرسايل",
  "copilot.response.whatsappIdle": "جلسة الواتساب حاليا في وضع الاستعداد وتحتاج مسح كود QR من صفحة المحادثات",
  "copilot.response.fallback": "رصيدك الحالي {{remaining}} رسالة متبقية والواتساب شغال تمام تحب اساعدك في ايه",

  // Copilot Engine
  "copilotEngine.howCanIHelp": "تفضل، كيف يمكنني مساعدتك؟",
  "copilotEngine.greetingHi": "اهلا {{name}} {{message}}",
  "copilotEngine.greetingHello": "السلام عليكم {{name}} {{message}}",
  "copilotEngine.preparedReplies": "تم تجهيز اقتراحات الرد على {{name}}",
  "copilotEngine.navigatingTab": "تم الانتقال الى صفحة {{tab}}",
  "copilotEngine.openingCampaign": "جاري فتح نافذة الحملات الجماعية",
  "copilotEngine.automationEnabled": "تم تشغيل الرد الالي",
  "copilotEngine.automationDisabled": "تم ايقاف الرد الالي",
  "copilotEngine.mediaReplyEnabled": "تم تفعيل الرد بواسطة {{mediaType}}",
  "copilotEngine.mediaReplyDisabled": "تم ايقاف الرد بواسطة {{mediaType}}",
  "copilotEngine.followupEnabled": "تم تفعيل المتابعة التلقائية",
  "copilotEngine.followupDisabled": "تم ايقاف المتابعة التلقائية",
  "copilotEngine.blacklistAdded": "تمت اضافة الرقم {{phone}} الى القائمة السوداء",
  "copilotEngine.blacklistRemoved": "تمت ازالة الرقم {{phone}} من القائمة السوداء",
  "copilotEngine.processError": "حدث خطأ اثناء معالجة الامر يرجى المحاولة مرة اخرى",

  // CRM Pipeline
  "crm.title": "مسار العملاء",
  "crm.tracked": "مُتابع",
  "crm.all": "الكل",
  "crm.noChats": "لا توجد محادثات. انتقل إلى تبويب واتساب لتحميل المحادثات أولاً.",
  "crm.untracked": "غير مُتابع",
  "crm.moveTo": "نقل إلى مرحلة",
  "crm.tags": "وسوم",
  "crm.manageStage": "إدارة المرحلة",
  "crm.addToLeadNew": "إضافة كعميل محتمل جديد",
  "crm.emptyStage": "لا توجد جهات اتصال في هذه المرحلة بعد",
  "crm.setupTitle": "إعداد مسار العملاء",
  "crm.setupDesc": "أنشئ تصنيفات واتساب لتتبع عملاءك خلال مراحل البيع — من العميل الجديد إلى العميل المغلق. هذا إعداد لمرة واحدة فقط.",
  "crm.settingUp": "جاري الإعداد...",
  "crm.setupBtn": "إنشاء تصنيفات المراحل",
  "crm.confirmSetup": "إنشاء تصنيفات المراحل؟",
  "crm.confirmSetupDesc": "سيتم إنشاء {{count}} تصنيف على جلسة واتساب: عميل محتمل جديد، قيد التواصل، تفاوض، عميل، مفقود — بالإضافة إلى وسوم عميل مهم وشكوى.",
  "crm.cancel": "إلغاء",
  "crm.createLabels": "إنشاء التصنيفات",
  "crm.refreshLabels": "تحديث التصنيفات",
  "crm.reset": "إعادة تعيين",
  "crm.resetTitle": "إعادة تعيين مسار العملاء؟",
  "crm.resetDesc": "سيؤدي هذا إلى حذف جميع تصنيفات إدارة العملاء من واتساب ومسح بيانات التتبع المحلية. لا يمكن التراجع عن هذا الإجراء.",
  "crm.confirmReset": "حذف جميع التصنيفات",
  "crm.stage.leadnew": "عميل محتمل جديد",
  "crm.stage.incontact": "قيد التواصل",
  "crm.stage.negotiating": "تفاوض",
  "crm.stage.customer": "عميل",
  "crm.stage.lost": "مفقود",
  "crm.addCustomer": "إضافة عميل",
  "crm.addCustomerTitle": "إضافة عميل جديد",
  "crm.addCustomerDesc": "أضف عميلًا غير موجود في المحادثات بعد لتتبعه ضمن مسار العملاء.",
  "crm.countryCodeLabel": "كود الدولة",
  "crm.phoneLabel": "رقم الهاتف",
  "crm.phonePlaceholder": "201234567890",
  "crm.digitsLeft": "متبقي {{count}} أرقام",
  "crm.digitsLeftOne": "متبقي رقم واحد",
  "crm.enterMoreDigits": "أدخل {{count}} أرقام أخرى",
  "crm.enterMoreDigitsOne": "أدخل رقم واحد آخر",
  "crm.phoneValid": "✓",
  "crm.nameLabel": "اسم العميل",
  "crm.namePlaceholder": "أدخل اسم العميل",
  "crm.stageLabel": "المرحلة الأولية",
  "crm.whatsappLabel": "تصنيف الواتساب",
  "crm.addBtn": "إضافة للمتابعة",
  "crm.addBtnSimple": "إضافة",
  "crm.adding": "جاري الإضافة...",
  "crm.invalidPhone": "أدخل رقم هاتف صحيح ({{digits}} أرقام)",
  "crm.alreadyExists": "هذا الرقم موجود بالفعل في قائمة المحادثات",
  "crm.manualEntry": "إدخال يدوي",
  "crm.importCsv": "استيراد CSV",
  "crm.importCsvTitle": "استيراد عملاء من CSV",
  "crm.importCsvDesc": "ارفع ملف CSV يحتوي على بيانات العملاء لإضافتهم دفعة واحدة إلى الـ Pipeline.",
  "crm.importCsvColumns": "الأعمدة المدعومة",
  "crm.importCsvColumnPhone": "الهاتف (مطلوب)",
  "crm.importCsvColumnName": "الاسم (اختياري)",
  "crm.importCsvColumnStage": "المرحلة (اختياري)",
  "crm.importCsvStageDefault": "الافتراضي: Lead جديد",
  "crm.importCsvStageOptions": "الخيارات المتاحة",
  "crm.importCsvDownloadTemplate": "تحميل قالب CSV",
  "crm.importCsvDropHere": "أسقط الملف هنا أو اضغط للرفع",
  "crm.importCsvCsvOnly": "ملفات CSV فقط",
  "crm.importCsvPreviewTitle": "معاينة ({{count}} عميل{{plural}})",
  "crm.importCsvNoValid": "لم يتم العثور على بيانات صالحة في الملف. تأكد من وجود عمود الهاتف.",
  "crm.importCsvWillImport": "سيتم استيراد {{count}} عميل{{plural}}",
  "crm.importCsvDuplicatesSkipped": "تم تخطي {{count}} مكرر{{plural}}",
  "crm.importCsvInvalidFile": "نوع ملف غير صالح. الرجاء رفع ملف .csv.",
  "crm.importCsvReadError": "فشل قراءة الملف. تأكد أنه ملف CSV صالح.",
  "crm.importCsvBtn": "استيراد {{count}} عميل{{plural}}",
  "crm.importCsvEmpty": "الملف فارغ أو لا يحتوي على بيانات صالحة.",
  "dashboard.tabs.crm": "CRM",

  // Catalog
  "dashboard.tabs.catalog": "الكتالوج",
  "catalog.title": "إدارة الكتالوج",
  "catalog.products": "منتجات",
  "catalog.cart": "السلة",
  "catalog.enableCart": "تفعيل السلة",
  "catalog.disableCart": "تعطيل السلة",
  "catalog.refresh": "تحديث",
  "catalog.tabProducts": "المنتجات",
  "catalog.tabCollections": "المجموعات",
  "catalog.searchProducts": "ابحث في المنتجات...",
  "catalog.allProducts": "كل المنتجات",
  "catalog.addProduct": "إضافة منتج",
  "catalog.noProducts": "لا توجد منتجات في الكتالوج",
  "catalog.addFirstProduct": "أضف منتجك الأول لبدء البيع",
  "catalog.noSearchResults": "لا توجد نتائج مطابقة",
  "catalog.noImage": "لا توجد صورة",
  "catalog.hidden": "مخفي",
  "catalog.edit": "تعديل",
  "catalog.show": "إظهار",
  "catalog.hide": "إخفاء",
  "catalog.delete": "حذف",
  "catalog.editProduct": "تعديل المنتج",
  "catalog.addProductBtn": "إضافة",
  "catalog.productName": "اسم المنتج",
  "catalog.productNamePlaceholder": "مثال: سماعات بلوتوث برو",
  "catalog.replaceImage": "استبدال الصورة",
  "catalog.productImage": "صورة المنتج",
  "catalog.clickToUpload": "انقر للرفع",
  "catalog.leaveEmptyToKeep": "اترك فارغاً للاحتفاظ بالصورة الحالية",
  "catalog.description": "الوصف",
  "catalog.descriptionPlaceholder": "وصف المنتج",
  "catalog.price": "السعر",
  "catalog.pricePlaceholder": "مثال: 299.99",
  "catalog.currency": "العملة",
  "catalog.productUrl": "رابط المنتج",
  "catalog.productUrlPlaceholder": "https://example.com/product",
  "catalog.retailerId": "معرف التاجر (SKU)",
  "catalog.retailerIdPlaceholder": "SKU001",
  "catalog.cancel": "إلغاء",
  "catalog.saveChanges": "حفظ التغييرات",
  "catalog.productAdded": "تم إضافة المنتج بنجاح",
  "catalog.productAddFailed": "فشل إضافة المنتج",
  "catalog.productUpdated": "تم تحديث المنتج",
  "catalog.productUpdateFailed": "فشل تحديث المنتج",
  "catalog.productDeleted": "تم حذف المنتج",
  "catalog.productDeleteFailed": "فشل حذف المنتج",
  "catalog.productShown": "تم إظهار المنتج",
  "catalog.productHidden": "تم إخفاء المنتج",
  "catalog.visibilityFailed": "فشل تغيير الظهور",
  "catalog.confirmDeleteProduct": "حذف المنتج؟",
  "catalog.confirmDeleteCollection": "حذف المجموعة؟",
  "catalog.cannotUndo": "لا يمكن التراجع عن هذا الإجراء.",
  "catalog.confirmDelete": "تأكيد الحذف",
  "catalog.collectionCount": "{{count}} مجموعة",
  "catalog.createCollection": "إنشاء مجموعة",
  "catalog.noCollections": "لا توجد مجموعات",
  "catalog.createFirstCollection": "أنشئ مجموعة لتنظيم منتجاتك",
  "catalog.collectionName": "اسم المجموعة",
  "catalog.collectionNamePlaceholder": "مثال: إلكترونيات",
  "catalog.selectProducts": "اختر المنتجات",
  "catalog.noProductsForCollection": "لا توجد منتجات متاحة",
  "catalog.createCollectionBtn": "إنشاء",
  "catalog.collectionCreated": "تم إنشاء المجموعة",
  "catalog.collectionCreateFailed": "فشل إنشاء المجموعة",
  "catalog.collectionUpdated": "تم تحديث المجموعة",
  "catalog.collectionUpdateFailed": "فشل تحديث المجموعة",
  "catalog.collectionDeleted": "تم حذف المجموعة",
  "catalog.collectionDeleteFailed": "فشل حذف المجموعة",
  "catalog.productsInCollection": "{{count}} منتج",
  "catalog.editCollection": "تعديل المجموعة",
  "catalog.cartToggleFailed": "فشل تغيير حالة السلة",
  "bulk.sendingActive": "حملة إرسال جماعي نشطة",
  "bulk.campaignScheduledShort": "إرسال مجدول",
  "bulk.scheduledFor": "مجدول في",
  "bulk.view": "عرض",
  "bulk.stopCampaign": "إيقاف",
  "bulk.sendingProgress": "تقدم الإرسال",

  // Bookings & Leads
  "bookings.title": "الحجوزات والطلبات",
  "bookings.subtitle": "متابعة وتأكيد الحجوزات والطلبات المسجلة تلقائياً من محادثات الواتساب",
  "bookings.export": "تصدير",
  "bookings.add": "إضافة",
  "bookings.save": "حفظ",
  "bookings.cancel": "إلغاء",
  "bookings.confirm": "تأكيد",
  "bookings.complete": "اكتمال",
  "bookings.delete": "حذف",
  "bookings.back": "رجوع",
  "bookings.status.pending": "قيد المراجعة",
  "bookings.status.confirmed": "مؤكد",
  "bookings.status.completed": "مكتمل",
  "bookings.status.cancelled": "ملغي",
  "bookings.type.booking": "حجز موعد",
  "bookings.type.order": "طلب شراء",
  "bookings.type.consultation": "استشارة / معاينة",
  "bookings.type.inquiry": "استفسار",
  "bookings.tracked": "مسجل",
  "bookings.addBooking": "إضافة حجز",
  "bookings.exportCsv": "تصدير CSV",
  "bookings.refresh": "تحديث",
  "bookings.all": "الكل",
  "bookings.loading": "جاري جلب الحجوزات...",
  "bookings.empty": "لا توجد حجوزات مسجلة حالياً",
  "bookings.emptyDesc": "يقوم الذكاء الاصطناعي برصد طلبات الحجز والاستفسارات من محادثات الواتساب تلقائياً.",
  "bookings.notes": "الملاحظات: ",
  "bookings.chat": "محادثة",
  "bookings.modalTitle": "إضافة حجز أو ليد جديد",
  "bookings.customerName": "اسم العميل",
  "bookings.customerNamePlaceholder": "مثلاً: أحمد محمود",
  "bookings.phoneLabel": "رقم الهاتف / الواتساب *",
  "bookings.typeLabel": "نوع المعاملة",
  "bookings.statusLabel": "الحالة",
  "bookings.serviceLabel": "الخدمة أو المنتج المطلوب",
  "bookings.servicePlaceholder": "مثلاً: كشف أسنان، باقة 3 شهور",
  "bookings.dateLabel": "التاريخ",
  "bookings.timeLabel": "الوقت",
  "bookings.notesLabel": "ملاحظات إضافية",
  "bookings.notesPlaceholder": "أي تفاصيل أو متطلبات خاصة...",

  // Dashboard V2 Master Redesign
  "v2.askTitle": "أهلاً، كيف أساعدك اليوم؟",
  "v2.askSubtitle": "اسأل المساعد الذكي عن أي شيء...",
  "v2.askPlaceholder": "اسأل المساعد الذكي عن رسائلك، حملاتك، أو أداء البوت...",
  "v2.linkedAccount": "جلسة الواتساب المتصلة",
  "v2.planMessagesLimit": "حد الرسائل",
  "v2.monthlyPlanFee": "الاشتراك الشهري للباقة",
  "v2.editLimits": "تعديل حدود الخطة",
  "v2.receiveAction": "استقبال",
  "v2.sendAction": "إرسال",
  "v2.totalMessages": "إجمالي الرسائل",
  "v2.aiTokens": "توكنز الذكاء الاصطناعي",
  "v2.viewChart": "عرض التفاصيل البيانية",
  "v2.weekly": "أسبوعي",
  "v2.monthly": "شهري",
  "v2.allTime": "الكل",
  "v2.systemLock": "الرد التلقائي",
  "v2.autoPilotActive": "الرد التلقائي: نشط",
  "v2.autoPilotPaused": "الرد التلقائي: متوقف",
  "v2.aiEnabled": "مفعل",
  "v2.aiDisabled": "معطل",
  "v2.aiUsage": "استهلاك AI",
  "v2.resolutionRate": "معدل الدقة والحل",
  "v2.planDays": "يوم",
  "v2.planHours": "109 ساعة، 23 دقيقة",
  "v2.liveEngagement": "حجم الاستجابة التلقائية",
  "v2.extendedTraffic": "الردود الذكية وسير العمل",
  "v2.mainStocks": "حجم الاستجابة والتفاعل",
  "v2.extendedLimited": "الردود الذكية وسير العمل",
  "v2.responseSpeed": "سرعة الاستجابة",
  "v2.instantLatency": "استجابة فورية فائقة",
  "v2.manualSpeed": "يدوي 4.2m",
  "v2.aiSpeed": "0.8s AI",
  "v2.speedImprovement": "+98% أسرع",
  "v2.activityManager": "إدارة الأنشطة والتدفقات",
  "v2.businessPlans": "مسارات الأتمتة",
  "v2.customerSupport": "دعم العملاء الذكي",
  "v2.salesOrders": "المبيعات والطلبات",
  "v2.appointmentBooking": "الحجوزات والمواعيد",
  "v2.walletVerification": "حماية الويب هوك والذكاء الاصطناعي",
  "v2.enableVerification": "تفعيل التحقق اللحظي لحماية استقبال رسائل الواتساب.",
  "v2.reviewRating": "تقييم التجربة",
  "v2.feedbackQuestion": "كيف تسير تجربة أتمتة\nأعمالك بالذكاء الاصطناعي؟",
  "v2.antiBanProtectionActive": "حماية ضد الحظر نشطة",
  "v2.whatsappNumberHealth": "صحة وأمان الحساب",
  "v2.autoRepliesTitle": "الردود التلقائية",
  "v2.weeklyEngagementGrowth": "تفاعل أسبوعي متصاعد",
  "v2.planTimeRemaining": "{{hours}} ساعة، {{minutes}} دقيقة",
  "v2.planCycle": "دورة الخطة",
  "v2.startRenewalTimeline": "تاريخ البدء والتجديد",
  "v2.aiRepliesTrend": "اتجاه الردود الذكية",
  "v2.healthLevel1.label": "خطر حظر مرتفع",
  "v2.healthLevel1.desc": "سرعة إرسال عالية مع غياب الردود",
  "v2.healthLevel1.actionHint": "تفعيل التوقف المؤقت التلقائي",
  "v2.healthLevel2.label": "مستوى تحذيري",
  "v2.healthLevel2.desc": "تكرار نصوص متطابقة بدون تنويع",
  "v2.healthLevel2.actionHint": "ننصح بتفعيل ميزة الـ Spintax",
  "v2.healthLevel3.label": "مستوى متوسط",
  "v2.healthLevel3.desc": "معدل تفاعل وتجاوب 14%",
  "v2.healthLevel3.actionHint": "زيادة الفواصل الزمنية إلى 18 ثانية",
  "v2.healthLevel4.label": "آمن ومستقر",
  "v2.healthLevel4.desc": "فواصل عشوائية ذكية مفعلة",
  "v2.healthLevel4.actionHint": "الحملات تعمل بكفاءة طبيعية",
  "v2.healthLevel5.label": "أمان فائق ومثالي",
  "v2.healthLevel5.desc": "تفاعل عالي وحماية مضادة للحظر",
  "v2.healthLevel5.actionHint": "أقصى درجات الموثوقية والأمان",
  "v2.whatsapp": "واتساب",
  "v2.planName.enterprise": "باقة متقدمة",
  "v2.planName.pro": "باقة برو",
  "v2.planName.basic": "باقة أساسية",
  "v2.activityManagerTitle": "إدارة الأنشطة وأنماط الرد",
  "v2.voiceNotes": "رسائل صوتية",
  "v2.smartMedia": "صور ووسائط",
  "v2.documents": "مستندات",
  "v2.dripFollowup": "متابعة ذكية",
  "v2.thisWeek": "هذا الأسبوع",
  "v2.chatsUnit": "محادثة",
  "v2.activeWhatsAppChats": "المحادثات النشطة على واتساب",
  "v2.liveChatPulse": "تفاعل مباشر",
  "v2.aiReplyModes": "أنماط الرد الذكي",
  "v2.voiceNotesTimelineTitle": "الرسائل الصوتية",
  "v2.voiceNotesTimelineDesc": "تحويل النص لصوت بشري",
  "v2.mediaTimelineTitle": "الصور والوسائط",
  "v2.mediaTimelineDesc": "إرسال صور وبروشورات",
  "v2.documentsTimelineTitle": "المستندات",
  "v2.documentsTimelineDesc": "إرسال ملفات الكتالوج",

  // Knowledge Base Tabs & AI Actions
  "kb.tabs.content": "بيانات المنشأة والكتالوج",
  "kb.tabs.actions": "AI Actions & API Tools",
  "actions.bannerBadge": "AI Function Calling",
  "actions.bannerTitle": "أدوات الذكاء الاصطناعي وربط الـ APIs الخارجية",
  "actions.bannerDesc": "زوّد المساعد الذكي بأدوات حية (Tools) لتتبع الشحنات، فحص النقاط، وجلب المخزون فورياً عبر الـ APIs مع حماية الـ Headers والمفاتيح السرية.",
  "actions.addNewTool": "إضافة أداة ذكية جديدة",
  "actions.libraryTitle": "قوالب سريعة بنقرة واحدة (1-Click Templates)",
  "actions.useTemplate": "تفعيل الأداة",
  "actions.activeToolsTitle": "الأدوات والإجراءات المفعّلة",
  "actions.toolsCount": "أدوات",
  "actions.emptyTitle": "لم يتم إعداد أدوات ذكاء اصطناعي بعد",
  "actions.emptyDesc": "أضف أداة جديدة أو اختر قالباً جاهزاً لتمكين المساعد من جلب وتحديث البيانات الخارجية أثناء المحادثة.",
  "actions.paramsLabel": "المعاملات:",
  "actions.testToolBtn": "تجربة الأداة",
  "actions.deleteConfirm": "هل أنت متأكد من حذف هذه الأداة؟",
  "actions.deletedSuccess": "تم حذف الأداة بنجاح.",
  "actions.savedSuccess": "تم حفظ الأداة بنجاح وتجهيزها للذكاء الاصطناعي!",
  "actions.presetApplied": "تمت إضافة الأداة من القالب بنجاح!",
  "actions.editActionTitle": "تعديل أداة الذكاء الاصطناعي (AI Tool)",
  "actions.newActionTitle": "إنشاء أداة ذكاء اصطناعي جديدة (AI Tool)",
  "actions.modalSubtitle": "تمكين المساعد الذكي من تنفيذ طلبات HTTP آمنة نيابة عنك أثناء محادثة العميل",
  "actions.quickPresets": "قوالب جاهزة:",
  "actions.tabs.basic": "بيانات الأداة والرابط",
  "actions.tabs.parameters": "معاملات الاستخراج (AI Parameters)",
  "actions.tabs.authHeaders": "المفاتيح السرية والترويسات (Headers)",
  "actions.tabs.bodyPayload": "جسم الطلب (JSON Body)",
  "actions.fields.toolName": "معرّف الأداة والوظيفة (Function Name) *",
  "actions.fields.toolNameHint": "اسم إنجليزي بدون مسافات يستخدمه المساعد الذكي (مثال: track_order)",
  "actions.fields.status": "الحالة",
  "actions.statusActive": "مفعّلة",
  "actions.statusDisabled": "معطّلة",
  "actions.fields.toolDesc": "شرح الأداة للذكاء الاصطناعي (AI Trigger Prompt) *",
  "actions.fields.toolDescPlaceholder": "مثال: استعلام عن حالة الشحنة ومكانها الحالي وموعد وصولها برقم الطلب",
  "actions.fields.toolDescHint": "اشرح بدقة متى وكيف يقرر المساعد الذكي استدعاء هذه الأداة بناءً على كلام العميل",
  "actions.fields.endpointUrl": "رابط ونوع الطلب (HTTP Method & Endpoint URL) *",
  "actions.fields.urlHint": "يدعم استبدال المعاملات تلقائياً مثل {{order_id}} أو {{customer_phone}}",
  "actions.params.title": "المعاملات المستخرجة بواسطة المساعد الذكي",
  "actions.params.desc": "المتغيرات التي يستخلصها الذكاء الاصطناعي من محادثة العميل لتمريرها للطلب",
  "actions.params.addParam": "إضافة معامل",
  "actions.params.paramName": "اسم المعامل",
  "actions.params.paramType": "النوع",
  "actions.params.paramLocation": "مكان التمرير",
  "actions.params.locQuery": "Query (الرابط ?)",
  "actions.params.locPath": "Path (مسار الرابط /:)",
  "actions.params.locBody": "Body (جسم الطلب JSON)",
  "actions.params.locHeader": "Header (الترويسات)",
  "actions.params.description": "وصف المعامل للـ AI",
  "actions.params.descPlaceholder": "رقم الطلب الذي يذكره العميل",
  "actions.params.defaultOrderIdDesc": "رقم الطلب",
  "actions.params.required": "مطلوب إجباري",
  "actions.headers.title": "ترويسات الطلب والمفاتيح السرية (HTTP Headers & Secrets)",
  "actions.headers.desc": "مفاتيح الـ API و Bearer Tokens تكون مشفرة وسرية تماماً ولا يطلع عليها الذكاء الاصطناعي.",
  "actions.headers.addHeader": "إضافة Header",
  "actions.body.title": "قالب جسم الطلب (Request JSON Body Template)",
  "actions.body.desc": "يمكنك وضع معاملات ديناميكية مثل {{order_id}} أو {{customer_phone}}",
  "actions.validation.nameRequired": "اسم الأداة (معرّف الوظيفة) مطلوب.",
  "actions.validation.descRequired": "شرح الأداة مطلوب ليعرف المساعد الذكي متى يستدعيها.",
  "actions.validation.urlRequired": "رابط الـ API المستهدف مطلوب.",
  "actions.testToolTitle": "تجربة واختبار الأداة المباشر",
  "actions.testParameters": "معاملات ومدخلات الأداة",
  "actions.noParamsRequired": "هذه الأداة لا تتطلب أي معاملات إضافية.",
  "actions.executing": "جاري إرسال الطلب وتنفيذ الأداة...",
  "actions.runTestNow": "تنفيذ الطلب التجريبي",
  "actions.toolOutput": "نتيجة استجابة الأداة (Tool Output)",
  "actions.aiIntegrationNote": "كيف يستفيد المساعد الذكي من هذه النتيجة:",
  "actions.aiExplanation": "يقوم المساعد الذكي بقراءة هذه البيانات JSON وصياغة رد ذكي فوري ولطيف بالعامية أو الفصحى للعميل على الواتساب دون كشف أي أسرار تقنية.",

  // Branches & Locations
  "kb.tabs.branches": "الفروع والمواقع",
  "branches.title": "الفروع المسجلة",
  "branches.newBranch": "فرع جديد",
  "branches.editBranch": "تعديل الفرع",
  "branches.configureLocation": "إعداد الموقع والتوصيل",
  "branches.addBranch": "إضافة فرع جديد",
  "branches.searchPlaceholder": "البحث في الفروع...",
  "branches.noBranches": "لا توجد فروع مسجلة حتى الآن.",
  "branches.selectBranchTitle": "اختر فرعاً للتعديل أو أضف فرعاً جديداً",
  "branches.selectBranchDesc": "قم بإدارة مواقع فروعك برابط Google Maps وسيتعرف الذكاء الاصطناعي على أقرب فرع للعميل تلقائياً على الواتساب.",
  "branches.fields.name": "اسم الفرع *",
  "branches.fields.namePlaceholder": "مثال: فرع المعادي / فرع التجمع الخامس",
  "branches.fields.status": "حالة الفرع",
  "branches.statusActive": "مفعّل للاستعلام",
  "branches.statusDisabled": "معطّل مؤقتاً",
  "branches.fields.mapLink": "رابط خريطة جوجل (Google Maps Link) *",
  "branches.fields.mapLinkPlaceholder": "https://maps.app.goo.gl/... أو https://google.com/maps/...",
  "branches.toggleDisable": "مفعل (اضغط للتعطيل)",
  "branches.toggleEnable": "معطل (اضغط للتفعيل)",
  "branches.useCurrentGps": "📍 التقاط موقعي الحالي",
  "branches.detectingGps": "جاري الالتقاط...",
  "branches.resolvingUrl": "جاري استخراج إحداثيات الموقع وتحديد الفرع...",
  "branches.fields.address": "العنوان بالتفصيل أو أقرب علامة مميزة",
  "branches.fields.addressPlaceholder": "مثال: شارع التسعين الشمالي، بجوار سيتي سنتر، الدور الأول",
  "branches.fields.hours": "مواعيد وساعات العمل",
  "branches.fields.hoursPlaceholder": "من 10 صباحاً حتى 11 مساءً",
  "branches.fields.phone": "رقم الهاتف للتواصل",
  "branches.liveMapPreview": "معاينة الخريطة الحية",
  "branches.openInMaps": "فتح في Google Maps",
  "branches.mapPlaceholder": "قم بوضع رابط Google Maps أو التقط موقعك لمعاينة الفرع هنا",
  "branches.enableDelivery": "تفعيل خدمة التوصيل وحساب التكلفة من هذا الفرع",
  "branches.maxRadius": "أقصى نطاق تغطية (كم)",
  "branches.baseFee": "سعر الشحن الأساسي (ج.م)",
  "branches.feePerKm": "سعر كل كم إضافي (ج.م)",
  "branches.savedSuccess": "تم حفظ بيانات الفرع بنجاح",
  "branches.deletedSuccess": "تم حذف الفرع بنجاح",
  "branches.deleteConfirm": "هل أنت متأكد من حذف هذا الفرع؟",
  "branches.validation.nameRequired": "اسم الفرع مطلوب",
  "branches.validation.locationRequired": "يرجى إدخال رابط Google Maps أو إحداثيات الموقع",
  "branches.validation.saveFailed": "فشل حفظ الفرع",

  // AI Voice Copilot
  "copilot.sendWhatsAppMessage": "إرسال رسالة واتساب",
  "copilot.sendTo": "إرسال إلى",
  "copilot.confirmAndSend": "تأكيد وإرسال",
  "copilot.cancel": "إلغاء",
  "copilot.sending": "جاري الإرسال...",
  "copilot.sentSuccessfully": "تم الإرسال بنجاح",
  "copilot.sendFailed": "فشل إرسال الرسالة",
  "copilot.processing": "جاري معالجة الأمر...",
  "copilot.messagePlaceholder": "اكتب نص الرسالة هنا...",
  "copilot.readyToSend": "جاهز لإرسال الرسالة إلى {{name}}",
  "copilot.navigatedTo": "تم الانتقال إلى {{tab}}",
  "copilot.openingCampaign": "جاري فتح نافذة الحملات الجماعية",
  "copilot.smartOptions": "3 اقتراحات ذكية للرد (اضغط لاختيار الرد وتعديله):",
  "copilot.sendThisReply": "إرسال هذا الرد فوراً",
  "copilot.startInternalThread": "بدء محادثة داخلية",

  // Platforms & Channel Hubs
  "platforms.all": "الكل",
  "platforms.allChats": "كل المحادثات",
  "platforms.whatsapp": "WhatsApp",
  "platforms.facebook": "Facebook",
  "platforms.instagram": "Instagram",
  "platforms.connected": "متصل",
  "platforms.waitingQr": "بانتظار المسح",
  "platforms.disconnected": "غير متصل",

  // Bulk channel tags
  "bulk.channelInstagram": "انستجرام",

  // Instagram Hub & Direct Messages
  "instagram.connectTitle": "ربط حساب Instagram Business",
  "instagram.connectDesc": "قم بربط حساب انستجرام الخاص بعملك لإدارة المحادثات، إرسال الرسائل، وتفعيل الردود الذكية بالذكاء الاصطناعي.",
  "instagram.autoDetectTab": "الربط التلقائي عبر فيسبوك",
  "instagram.manualTab": "الربط اليدوي المباشر",
  "instagram.connectedAccount": "حساب انستجرام متصل",
  "instagram.active": "نشط",
  "instagram.messagesReady": "استقبال وإرسال الرسائل:",
  "instagram.aiResponses": "الرد الذكي بالذكاء الاصطناعي:",
  "instagram.disconnect": "فصل الحساب",
  "instagram.fbNotConnected": "صفحة الفيسبوك غير متصلة",
  "instagram.fbNotConnectedDesc": "للربط التلقائي، يُرجى ربط صفحة الفيسبوك المرتبطة بحساب انستجرام أولاً، أو استخدام تبويب 'الربط اليدوي'.",
  "instagram.detecting": "جارٍ فحص حساب انستجرام المرتبط بصفحة فيسبوك...",
  "instagram.detectedReady": "تم العثور على الحساب بنجاح. يمكنك ربطه الآن مباشرة باستخدام نفس تصريح صفحة فيسبوك.",
  "instagram.connectNow": "ربط هذا الحساب الآن",
  "instagram.noAccountFound": "لم يتم العثور على حساب انستجرام تجاري مرتبط بصفحة فيسبوك المتصلة.",
  "instagram.requirementsTitle": "الشروط المطلوبة للربط:",
  "instagram.req1": "أن يكون الحساب نوعه احترافي (Professional / Business / Creator).",
  "instagram.req2": "أن يكون مربوطاً بصفحة الفيسبوك من إعدادات Page Settings.",
  "instagram.req3": "تفعيل خيار (Allow Access to Messages) من إعدادات تطبيق انستجرام.",
  "instagram.accountIdLabel": "معرّف حساب انستجرام (Instagram Account ID)",
  "instagram.tokenLabel": "رمز وصول الصفحة / الحساب (Page / User Access Token)",
  "instagram.connectManualSubmit": "التحقق والربط",
  "instagram.connectedSuccess": "تم ربط حساب انستجرام بنجاح!",
  "instagram.requiredFields": "يرجى إدخال معرّف الحساب والرمز المميز.",
  "instagram.defaultUser": "مستخدم انستجرام",
  "instagram.noLinkedAccount": "لا يوجد حساب انستجرام تجاري مرتبط بصفحة الفيسبوك هذه. تأكد من ربطه في إعدادات الصفحة.",

  "facebook.messengerInbox": "محادثات الماسنجر",
  "facebook.messengerSub": "Facebook Messenger",
  "facebook.messengerNotConnectedTitle": "الماسنجر غير متصل حالياً",
  "facebook.messengerNotConnectedDesc": "يرجى ربط صفحة فيسبوك الرسمية من خلال إدخال Page ID و Access Token في النموذج المقابل لتفعيل استقبال وإرسال الرسائل.",
  "facebook.integrationTitle": "ربط صفحة فيسبوك الرسمية",
  "facebook.readyToConnect": "جاهز للربط",
  "facebook.credentialsTitle": "إعدادات الربط والـ API",
  "facebook.credentialsDesc": "أدخل معرّف الصفحة ورمز الوصول الدائم لربط الماسنجر وتعليقات المنشورات تلقائياً مع نظام وايزون.",
  "facebook.pageNameLabel": "اسم الصفحة (Page Name)",
  "facebook.pageNamePlaceholder": "اسم صفحتك على فيسبوك",
  "facebook.pageIdLabel": "معرّف الصفحة (Page ID) *",
  "facebook.accessTokenLabel": "رمز الوصول الدائم (Page Access Token) *",
  "facebook.connectBtn": "Connect & Verify Page",
  "facebook.verifyingBtn": "جاري التحقق والربط...",
  "facebook.disconnectBtn": "فصل",
  "facebook.disconnectConfirm": "هل أنت متأكد من إلغاء ربط صفحة فيسبوك؟",
  "facebook.validation.pageId": "يرجى إدخال معرّف الصفحة (Page ID)",
  "facebook.validation.accessToken": "يرجى إدخال رمز الوصول (Page Access Token)",
  "facebook.defaultPageName": "صفحة فيسبوك",
  "facebook.messengerActive": "متصل بالماسنجر",
  "facebook.searchPlaceholder": "ابحث في محادثات ماسنجر...",
  "facebook.noMessagesTitle": "لا توجد رسائل بعد",
  "facebook.noMessagesDesc": "ستظهر رسائل العملاء القادمة عبر الماسنجر أو تعليقات المنشورات هنا تلقائياً فور وصولها.",
  "facebook.selectChatTitle": "محادثات فيسبوك ماسنجر",
  "facebook.selectChatDesc": "اختر محادثة من القائمة لعرض الرسائل المتبادلة والرد على العميل مباشرة.",
  "facebook.aiReplyOn": "الرد الذكي مفعّل",
  "facebook.aiReplyOff": "معطّل",
  "facebook.noHistory": "لا توجد رسائل سابقة في هذه المحادثة.",
  "facebook.aiBadge": "رد الذكاء الاصطناعي",
  "facebook.typeReplyPlaceholder": "اكتب رداً على الماسنجر...",
  "facebook.sendBtn": "إرسال",
  "facebook.justNow": "الآن",
  "facebook.webhookSuccess": "تم التحقق من الصفحة واشتراك الـ Webhooks بنجاح لاستقبال الرسائل والتعليقات!",
  "facebook.subscribedStatus": "الـ Webhooks نشطة (الرسائل والمنشورات)",
  "facebook.loadingChats": "جاري تحميل محادثات الماسنجر...",
  "facebook.refreshChats": "تحديث المحادثات",
  "facebook.conversationsCount": "{{count}} محادثة",
  "facebook.fetchError": "تعذر جلب المحادثات من فيسبوك",
  "facebook.retryBtn": "إعادة المحاولة",
  "facebook.anonymousUser": "مستخدم فيسبوك",
  "facebook.tokenExpired": "انتهت صلاحية رمز وصول فيسبوك (Meta Access Token Expired). الرمز المستخدم مؤقت، يرجى تحديث الرمز أو استخدام رمز دائم (Never-Expiring System User Token).",
  "facebook.pageTokenRequired": "يجب استخدام رمز وصول الصفحة (Page Access Token) وليس رمز المستخدم. اختر صفحتك من قائمة User or Page في Graph API Explorer.",
  "facebook.connectionAlert": "تنبيه بخصوص ربط فيسبوك",
  "facebook.reconnectBtn": "تحديث الرمز / إعادة الربط",
  "facebook.tokenLifespanNotice": "تنبيه هام حول صلاحية الرمز (Token Lifetime):",
  "facebook.tokenLifespanDesc": "الرموز المستخرجة من Graph API Explorer تنتهي صلاحيتها تلقائياً خلال 24 ساعة (وتسبب ظهور خطأ 400 وتوقف الشات). لضمان استمرار الخدمة دون توقف، استخدم رمز مستخدم النظام (System User) الدائم.",
  "facebook.howToCreatePermanentToken": "كيف تنشئ رمزاً دائماً؟",
  "facebook.hideGuide": "إخفاء الدليل",
  "facebook.permanentGuideTitle": "طريقة استخراج رمز دائم لا ينتهي أبداً (Never Expire):",
  "facebook.permanentGuideStep1": "افتح إعدادات الأعمال (Meta Business Settings) -> انتقل إلى Users ثم System Users.",
  "facebook.permanentGuideStep2": "أنشئ مستخدم نظام (System User) بصلاحية Admin، واضغط Add Assets وحدد صفحتك مع تفعيل Full Control.",
  "facebook.permanentGuideStep3": "اضغط Generate New Token، حدد تطبيقك، واختر مدة الصلاحية: Never (لا ينتهي أبداً).",
  "facebook.permanentGuideStep4": "حدد الصلاحيات المطلوبة (pages_messaging, pages_manage_metadata, pages_show_list, pages_read_engagement) ثم انسخ الرمز والصقه هنا.",

  // Common Channel & Pipeline keys
  "channels.awaitingSetup": "في انتظار الربط",
  "channels.connectionError": "خطأ في عملية الربط",
  "channels.serverSaveError": "تعذر حفظ الربط على السيرفر.",
  "channels.paste": "لصق من الحافظة",
  "channels.pasted": "تم اللصق!",
  "channels.show": "إظهار",
  "channels.hide": "إخفاء",
  "channels.copy": "نسخ",
  "channels.copied": "تم!",
  "channels.copyUrl": "نسخ الرابط",
  "channels.copyToken": "نسخ الرمز",
  "channels.copyFields": "نسخ الحقول",
  "channels.clickToCopyScope": "انقر لنسخ الصلاحية",
  "channels.clickCodeToCopy": "انقر على الكود للنسخ",
  "channels.requiredBadge": "إلزامية",
  "channels.commentsBadge": "للتعليقات",
  "channels.contextBadge": "سياق البوست",
  "channels.pipelineTitle": "مسار تدفق البيانات والصلاحيات",
  "channels.openMetaDevelopers": "فتح لوحة مطوري Meta",
  "channels.stage1Title": "ترحيل البايلود إلى الويب هوك",
  "channels.stage2Title": "التوجيه لنقطة نهاية وايزون",
  "channels.webhookConfigTitle": "بيانات الـ Webhook الخاص بنا",
  "channels.webhookDataLines": "خطوط إعدادات الويب هوك (Webhook Setup Data Lines):",
  "channels.callbackUrlLabel": "رابط الـ Webhook (Callback URL)",
  "channels.verifyTokenLabel": "رمز التحقق (Verify Token)",
  "channels.webhookFieldsLabel": "حقول الاشتراك (Subscription Fields)",
  "channels.fieldsReadyBadge": "حقول جاهزة للاشتراك",
  "channels.scopeFlowLines": "خطوط الصلاحيات المفعلة لهذا الحدث (Scope Flow Lines):",
  "channels.gatewayFlowLines": "خطوط الصلاحيات المفعلة لهذا المسار (Scope Flow Lines):",
  "channels.outboundScopeFlowLines": "خطوط الصلاحيات المفعلة لإرسال الردود (Scope Flow Lines):",
  "channels.outboundAiDecision": "معالجة الذكاء الاصطناعي وتجهيز الرد",
  "channels.outboundTitle": "التنفيذ الفوري والرد (Outbound Action)",
  "channels.actionAndClosing": "Action & Closing",
  "channels.liveTraffic": "حركة بيانات حية (Live Traffic)",
  "channels.triggerOnMeta": "Trigger on Meta",
  "channels.liveDispatch": "Live Dispatch",
  "channels.privateDmBadge": "رسائل خاصة",
  "channels.profileBadge": "الملف الشخصي",

  // Instagram Hub & Service additions
  "instagram.connectHeaderTitle": "ربط قنوات انستجرام والرسائل المباشرة",
  "instagram.connectHeaderSubtitle": "أدخل معرّف حساب انستجرام التجاري ورمز الوصول الدائم لربط محادثات الـ Direct والتعليقات مع أتمتة الرد الذكي المباشر.",
  "instagram.accountNameLabel": "اسم حساب انستجرام (اختياري)",
  "instagram.accountNamePlaceholder": "مثال: brand_official@",
  "instagram.accountIdField": "معرّف حساب انستجرام (Instagram Business Account ID)",
  "instagram.numericIdOnly": "أرقام فقط (Numeric ID)",
  "instagram.accessTokenField": "رمز وصول الصفحة / الحساب (Page / Access Token)",
  "instagram.tokenPlaceholderHint": "رمز وصول ممتد المفعول يبدأ بـ EAA... مع الصلاحيات الموضحة في مسار البيانات المقابل.",
  "instagram.tokenSecurityHint": "يتم تشفير وتأمين رمز الوصول الدائم عبر خوادم Wyzon الآمنة وتأمينه لمنع أي وصول غير مصرح به.",
  "instagram.verifyingConnecting": "جاري فحص الصلاحيات وربط الحساب...",
  "instagram.verifyAndConnectBtn": "تحقق واشتراك بحساب انستجرام (Verify & Connect)",
  "instagram.pipelineDesc": "مخطط تفاعلي يربط صلاحيات انستجرام بمسار تدفق الأحداث الحية بين Meta ووايزون",
  "instagram.inboundTitle": "استقبال تفاعل العميل (Customer Inbound Interaction)",
  "instagram.inboundDesc": "يبدأ المسار عند إرسال العميل رسالة في انستجرام Direct أو كتابة تعليق على منشور.",
  "instagram.scopeDirectDesc": "وارد الرسائل المباشرة: استلام محادثات Direct والمقاطع الصوتية والمرفقات",
  "instagram.scopeCommentsDesc": "تغذية التعليقات: رصد تعليقات وتفاعلات الزوار على البوستات والريلز",
  "instagram.scopeContextDesc": "سياق المنشور: قراءة نص المنشور الأصلي وسياقه لتغذية الذكاء الاصطناعي بدقة الرد",
  "instagram.bridgeTitle": "جسر المزامنة اللحظي (Real-Time Webhook Bridge)",
  "instagram.bridgeDesc": "تمرير البايلود مباشرة إلى خوادم Wyzon والتحقق من اشتراك الحساب.",
  "instagram.scopeWebhookDesc": "اشتراك الـ Webhooks: إدارة قنوات البث اللحظي واشتراك الويب هوك تلقائياً",
  "instagram.scopeIdentityDesc": "التحقق من الهوية: التأكد من معرّف حساب انستجرام وصحة ملكية الحساب",
  "instagram.outboundDesc": "إرسال ردود الذكاء الاصطناعي المباشرة إلى انستجرام Direct والرد على التعليقات.",
  "instagram.scopeSendDmDesc": "إرسال رسائل Direct: تسليم ردود الذكاء الاصطناعي فورا لشات العميل",
  "instagram.scopeReplyCommentsDesc": "الرد على التعليقات: نشر ردود ذكية على التعليقات وإدارة التفاعل",
  "instagram.validation.missingId": "يرجى إدخال معرّف حساب انستجرام (Instagram Business Account ID)",
  "instagram.validation.missingToken": "يرجى إدخال رمز وصول الصفحة / الحساب (Access Token)",
  "instagram.verifyFailed": "تعذر التحقق من حساب انستجرام. تأكد من صحة الـ Token والمعرّف.",
  "instagram.connectedToast": "تم التحقق من حساب انستجرام وربطه بنجاح!",
  "instagram.chatSearchPlaceholder": "ابحث في محادثات انستجرام...",
  "instagram.noChatsTitle": "لا توجد رسائل بعد",
  "instagram.noChatsDesc": "ستظهر رسائل العملاء القادمة عبر Direct هنا تلقائياً فور وصولها.",
  "instagram.selectChatTitle": "محادثات انستجرام Direct",
  "instagram.selectChatDesc": "اختر محادثة من القائمة لعرض الرسائل المتبادلة والرد على العميل مباشرة.",
  "instagram.typeReplyPlaceholder": "اكتب رداً على انستجرام Direct...",
  "instagram.aiReplyActive": "الرد الذكي مفعّل",
  "instagram.aiReplyDisabled": "معطّل",
  "instagram.disconnectConfirm": "هل أنت متأكد من إلغاء ربط حساب انستجرام؟",
  "instagram.howToCreatePermanentToken": "كيف تنشئ رمزاً دائماً؟",
  "instagram.hideGuide": "إخفاء الدليل",
  "instagram.permanentGuideTitle": "طريقة استخراج رمز دائم لحساب انستجرام (Never Expire):",
  "instagram.permanentGuideStep1": "افتح إعدادات الأعمال (Meta Business Settings) -> انتقل إلى Users ثم System Users.",
  "instagram.permanentGuideStep2": "أنشئ مستخدم نظام (System User) بصلاحية Admin، واضغط Add Assets وحدد صفحة فيسبوك وحساب انستجرام مع تفعيل Full Control.",
  "instagram.permanentGuideStep3": "اضغط Generate New Token، حدد تطبيقك، واختر مدة الصلاحية: Never (لا ينتهي أبداً).",
  "instagram.permanentGuideStep4": "حدد الصلاحيات المطلوبة (instagram_basic, instagram_manage_messages, pages_manage_metadata, pages_read_engagement) ثم انسخ الرمز والصقه هنا.",
  "instagram.pageNotLinked": "صفحة فيسبوك ({{pageName}}) غير مربوطة بحساب انستجرام تجاري. يرجى إتمام ربط انستجرام بالصفحة أولاً.",
  "instagram.userTokenRequiresPageToken": "الرمز المُدخل هو رمز مستخدم (User Token). تتطلب شركة Meta استخدام رمز وصول الصفحة (Page Access Token) الخاصة بحساب انستجرام لقراءة وإرسال المحادثات. اختر اسم صفحة الفيسبوك في Graph API Explorer لتوليد الرمز الصحيح.",
  "instagram.conversationsRequirePageToken": "يتطلب Meta رمز وصول الصفحة (Page Access Token) وليس رمز مستخدم (User Token). يرجى الضغط على إعادة الربط واستخدام رمز الصفحة.",

  // Facebook Hub & Service additions
  "facebook.connectHeaderTitle": "ربط قنوات فيسبوك وماسنجر",
  "facebook.pipelineDesc": "مخطط تفاعلي يربط صلاحيات فيسبوك بمسار تدفق الأحداث الحية بين Meta ووايزون",
  "facebook.inboundTitle": "استقبال تفاعل العميل (Customer Inbound)",
  "facebook.inboundDesc": "يبدأ المسار عند إرسال العميل رسالة في الماسنجر أو كتابة تعليق على منشور.",
  "facebook.scopeMessengerDesc": "وارد الماسنجر: استلام محادثات الشات والرسائل الصوتية والمرفقات لحظياً",
  "facebook.scopeCommentsDesc": "تغذية التعليقات: رصد تعليقات واستفسارات العملاء على منشورات وفيديوهات الصفحة",
  "facebook.scopeContextDesc": "سياق المنشور: قراءة نص البوست الأصلي ومحتواه لتغذية الذكاء الاصطناعي بدقة الإجابة",
  "facebook.bridgeTitle": "جسر المزامنة اللحظي (Webhook Gateway)",
  "facebook.bridgeDesc": "تمرير البايلود مباشرة إلى خوادم Wyzon والتحقق من اشتراك الصفحة.",
  "facebook.scopeWebhookDesc": "اشتراك الـ Webhooks: تفعيل قنوات البث اللحظي وإدارة اشتراك الصفحة تلقائياً",
  "facebook.scopeIdentityDesc": "التحقق من الهوية: التأكد من معرّف الصفحة وصحة صلاحيات الحساب الإداري",
  "facebook.tokenPlaceholderHint": "رمز وصول ممتد المفعول يبدأ بـ EAA... مع الصلاحيات الموضحة في مسار البيانات المقابل.",
  "facebook.tokenSecurityHint": "يتم تشفير وتأمين رمز الوصول الدائم عبر خوادم Wyzon الآمنة وتأمينه لمنع أي وصول غير مصرح به.",
  "facebook.verifyingConnecting": "جاري فحص الصلاحيات وربط الـ Webhooks...",
  "facebook.verifyAndConnectBtn": "تحقق واشتراك بالصفحة (Connect Page)",
  "facebook.verifyFailed": "تعذر التحقق من صفحة فيسبوك. تأكد من صحة الـ Token ومعرّف الصفحة.",
  "facebook.connectedToast": "تم التحقق من صفحة فيسبوك والاشتراك بنجاح!",
  "facebook.outboundDesc": "إرسال الرد الاستشاري للماسنجر ونشر الرد العام وعمل Like على التعليقات.",
  "facebook.scopeSendDmDesc": "إرسال رسائل الماسنجر: تسليم إجابات الذكاء الاصطناعي المباشرة إلى شات العميل",
  "instagram.scopeDirectOutDesc": "إرسال الردود المباشرة: إرسال ردود الذكاء الاصطناعي والكتالوجات في شات Direct",
  "instagram.scopeCommentsOutDesc": "التفاعل العام: نشر ردود عامة باسم الحساب على تعليقات العملاء في الريلز والبوستات",
  "instagram.scopeBasicOutDesc": "تأكيد الملف الرسمي: إرسال الردود موثقة رسمياً باسم وشعار الحساب التجاري",
  "facebook.scopeReplyCommentsDesc": "الرد التفاعلي على البوستات: نشر ردود ذكية على التعليقات وإدارة المحادثة العامة",
  "facebook.scopeManagePostsDesc": "الرد الخاص (Private DM): إرسال رسالة ماسنجر خاصة للمستخدم الذي علق على المنشور",
  "facebook.pageNamePlaceholderExample": "مثال: صفحة المتجر الرسمي",
  "instagram.webhookConfigSubtitle": "إعدادات الربط المباشرة لإدخالها في إعدادات تطبيق Meta > Webhooks > Instagram.",
  "channels.routeToWyzon": "التوجيه لنقطة نهاية وايزون",

  // AiComposer / AiMessageModal
  "aiComposer.title": "صياغة رسالة ذكية",
  "aiComposer.close": "إغلاق",
  "aiComposer.textMessage": "رسالة نصية",
  "aiComposer.voiceNote": "فويس نوت",
  "aiComposer.promptLabel": "تعليمات الرسالة (Prompt)",
  "aiComposer.promptPlaceholder": "مثال: اشكره على الطلب وقوله إننا مستنين رأيه وقدم له كود خصم 10%...",
  "aiComposer.presetThankOrder": "شكر على الطلب",
  "aiComposer.presetThankOrderPrompt": "اشكره على طلبه وأخبره أننا نسعد بخدمته ونسعى لمعرفة رأيه",
  "aiComposer.presetDiscount": "عرض خصم",
  "aiComposer.presetDiscountPrompt": "قدم له كود خصم خاص 10% على طلبه القادم تقديراً له",
  "aiComposer.presetShipping": "تأكيد الشحن",
  "aiComposer.presetShippingPrompt": "أبلغه بأن طلبه تم تجهيزه وجاري شحنه وسيصل قريباً",
  "aiComposer.presetFollowup": "متابعة واستفسار",
  "aiComposer.presetFollowupPrompt": "اسأله عما إذا كان لديه أي استفسار أو بحاجة لأي مساعدة",
  "aiComposer.generatingDraft": "جاري صياغة المسودة...",
  "aiComposer.draftPreview": "معاينة المسودة (قابلة للتعديل)",
  "aiComposer.processingResponse": "جاري معالجة الرد...",
  "aiComposer.insertToChat": "إدراج في الشات",
  "aiComposer.sendVoice": "إرسال فويس",
  "aiComposer.send": "إرسال",
  "aiComposer.preview": "معاينة",
  "aiComposer.copy": "نسخ",
  "aiComposer.copied": "تم النسخ",
  "aiComposer.errorNoDraft": "لم يتم استلام رد يرجى المحاولة ثانية",
  "aiComposer.errorSendFailed": "فشل إرسال الرسالة يرجى المحاولة ثانية",
  "aiComposer.errorVoiceSendFailed": "فشل إرسال الرسالة الصوتية",

  // DashboardTopHeader
  "header.listeningToVoice": "جاري الاستماع لصوتك الآن...",
  "header.listeningClickStop": "جاري الاستماع... اضغط للإيقاف",
  "header.speakWithAssistant": "تحدث مع المساعد الذكي",

  // DashboardNavRail
  "navRail.theme": "المظهر",
  "navRail.colors": "الألوان",
};

export default dashboard;
